/**
 * Game Controller Class
 *
 * Handles the main game flow
 *
 * Also has some specific cascade reels functionality here
 */

/* module manages the main game this inherits from spinFunctions */

gameController = (function () {
  var _payWinsEvent = {};
  var _poppingSymbols = [];
  var _dropEvent = [];
  var _dropsRemaining = 0;
  var _reelToFrespinsBarFlying = 0;
  var _popAndDropCompleteEvent = 0;
  var _totalWinnings = 0;
  var _numberOfPops = 0;
  var _jackpotTask;
  var _currentTime;
  var _featureAwarded = false;
  var _animWinsFinished = false;
  var _singleAnimWinFinished = false;
  var _skipWin = false;
  var _anticipationSymbolsLanding = 0;
  var _anticipationSymbolsLanded = 0;
  var _bonusSymbolsLanded = 0;
  var _initialDropping = 0;
  var _bigWin = undefined;
  var _inBuyABonus = false;
  var _specialEvent = false;
  var inBuyABonusRecovery = false;
  var _inBuyASuperBonus = false;
  var inRecovery = false;
  var _popData = [];
  var _tempPopData = [];
  var _allPopsComplete = false;
  var _symbolDisappearAnims = [];
  var _wildBlastAnims = [];
  var _landedAnimsPlayingData = [];
  var _symbolCallbackFired = [];
  var _bgTrail = undefined;
  var logoIdleTimeline = undefined;
  var titleAnim = undefined;
  var _freeSpinsMeter = undefined;
  var _modifierEventTriggered = false;
  var _spinBonusSounds = ['bonusLand1', 'bonusLand2', 'bonusLand3', 'bonusLand4', 'bonusLand5', 'bonusLand6'];
  var _spinSounds = ['startPressed1', 'startPressed2', 'startPressed3'];
  var _lastRandomSpinSoundIndex = -1;
  var _explodeSounds = ['explode1', 'explode2', 'explode3'];
  var _dropFinishedSounds = ['dropFinished1', 'dropFinished2', 'dropFinished3', 'dropFinished4'];
  var _lastRandomDropFinishedSoundIndex = -1;
  var _isGameIdle = true;
  var _fullGameWinnings = 0;
  var _isPrePaid = false;
  var _gambleMode = 'on';
  var _rng = new RNG();
  var _colossalData = null;
  var _showingMaxWinPopup = false;
  var _maxWinShown = false;
  var _winningsMeterCapped = false;
  var _eggWobbleTimer = null;
  var _slamStopRequested = false;

  var _gambleModeModes = ['five', 'on', 'off'];
  var _gambleMode = 'five';
  var _gambleModeIndex = 0;

  var _numPoppingSymbols = 0;
  var _colossalConvertTaskToLeave = null;

  var _allLandAnimsFinished = false;
  var _startAnticipationDelayFromReel = -2;

  function switchGambleMode() {
    let len = _gambleModeModes.length - 1;
    let temp = _gambleModeIndex;
    temp++;

    if (temp < 0) {
      temp = len;
    } else if (temp > len) {
      temp = 0;
    }

    _gambleModeIndex = temp;
    _gambleMode = _gambleModeModes[temp];

    return temp;
  }

  function resetWinnings() {
    _totalWinnings = 0;
    _numberOfPops = 0;
    _maxWinShown = false;
    _winningsMeterCapped = false;
    _scatterWinPostponed = false;
  }

  function jackpotGame(task) {
    _jackpotTask.join();

    const capped = false;
    _bigWin.start(task.data.value, capped, null, null, () => {
      _jackpotTask.leave();
    });
  }

  function recoverGame(task) {
    if (task.data.clientParams?.Params) {
      const mode = task.data.clientParams.Params.mode;

      const gambleModeButton = resourceManager.get('buttonContainer:buttonBar:gambleModeButton');
      gambleModeButton.switchMode(mode);
      _gambleMode = _gambleModeModes[mode];
      _gambleModeIndex = mode;
    }

    // Recovery game with encore
    if (task.data.metaData === 'encore' && gameData.encoreEnabled !== task.data.metaValue) {
      // Clear any encore effects and stop them appearing again
      gameData.encoreEnabled = task.data.metaValue;

      // Put button in the right state if not already true
      var encoreButtonLB = resourceManager.get('buttonContainer:buttonBar:luckyBetToggleButton');

      if (encoreButtonLB._flags.showLuckyBetActive !== gameData.encoreEnabled) {
        encoreButtonLB.setRecovery();
      }
    }

    inRecovery = true;
    resourceManager.get('helpPageScrollContainer:helpPageScroll').close();

    if (task.data.metaData === 'buyABonus' && task.data.metaValue) {
      gameController.inBuyABonus = true;
      inBuyABonusRecovery = true;

      let baseStake = gameData.recoveryStake;

      let stakeController = resourceManager.getController('stakeController');

      let stakes = stakeController.Stakes;
      let returnStake = stakes.find((stake) => stake === baseStake);

      if (!returnStake) {
        returnStake = stakes[0];
      }

      stakeController.requestChangeStake(returnStake);
      stakeController.requestChangeStake(baseStake, 'BONUS_BUY_NORMAL');

      gameData.stakeMeter.set(baseStake);

      initNewSpin();
    } else if (task.data.metaData === 'buyASuperBonus' && task.data.metaValue) {
      gameController.inBuyASuperBonus = true;
      inBuyABonusRecovery = true;

      let baseStake = gameData.recoveryStake;

      let stakeController = resourceManager.getController('stakeController');

      let stakes = stakeController.Stakes;
      let returnStake = stakes.find((stake) => stake === baseStake);

      if (!returnStake) {
        returnStake = stakes[0];
      }

      stakeController.requestChangeStake(returnStake);
      stakeController.requestChangeStake(baseStake, 'BONUS_BUY_SUPER');

      gameData.stakeMeter.set(baseStake);

      initNewSpin();
    } else {
      initNewSpin();
    }
  }

  function updateStake() {
    let stakeController = resourceManager.getController('stakeController');
    let baseStake = stakeController.BaseStake;
    let bpl = baseStake / 25;
    let luckyBetEnabled = gameData.encoreEnabled;

    stakeController.setStakeMultiplier(luckyBetEnabled ? 1.25 : 1);
    game.changeStake(baseStake * (luckyBetEnabled ? 1.25 : 1), bpl);
    stakeController.broadcastCurrentStake();
  }

  function onPromotionStarted() {
    _isPromotion = true;
  }

  function onPromotionEnded() {
    _isPromotion = false;
  }

  function canEnableSkip() {
    return false; //gameController.stateMachine.ActiveStateName === 'PAYWINS' && !_skipWin;
  }

  async function hideGameLogo(durationInMS = 100, instant = false) {
    const logo = resourceManager.get('slotContainer:logoContainer');
    if (!instant) {
      await game.tweenFromToAsync(
        logo,
        {
          alpha: 1,
        },
        {
          alpha: 0,
          duration: durationInMS / 1000,
          ease: 'none',
        }
      );
    }
    logo.alpha = 0;
    logo.visible = false;
  }

  async function showGameLogo(durationInMS = 100, instant = false) {
    const logo = resourceManager.get('slotContainer:logoContainer');

    logo.visible = true;
    if (!instant) {
      await game.tweenFromToAsync(
        logo,
        {
          alpha: 0,
        },
        {
          alpha: 1,
          duration: durationInMS / 1000,
          ease: 'none',
        }
      );
    }
    logo.alpha = 1;
  }

  function initNewSpin() {
    // Start of new game
    gameController._receivedResponse = false;

    gameController.stopRandomEggWobbleTimer();

    _isGameIdle = false;

    gameController.resetWinnings();

    _bgTrail.reset();
    gameController.playEggWobbleIfRequired(true);
    _outcomesPanel.removeEntries();

    musicManager.onGameStart();

    gameController.reelsSpinning = [false, false, false, false, false]; //gameData.reels.length;
    gameData.winningsContainer.visible = false;
    gameData.messageContainer.visible = true;
    gameData.spinToWinText.visible = false;
    gameData.goodLuckText.visible = true;
    gameData.winningsMeter.set(0);

    var config = resourceManager.get('slotContainer').Props.configValues;

    gameData.reels.forEach(function (value) {
      value.setSpinParameters({
        spinSpeed: config.spinSpeed,
        landOffset: config.landOffset,
        decelerationDistance: config.decelerationDistance,
      });
    });

    _payWinsEvent = undefined;
    gameController.spinTask = undefined;

    _anticipationSymbolsLanding = 0;
    _anticipationSymbolsLanded = 0;
    _bonusSymbolsLanded = 0;

    slotMachine.clearReels(_colossalData);

    // this needs to go to an intermediate state until the drop is finished - then into reels_spinning
    console.log('gameController::switchState to CLEAR_REELS');
    gameController.stateMachine.switchState('CLEAR_REELS');

    // Update autoplay button text
    var spinsRemaining = autoplayManager.getRemainingRounds();
    var spinsRemainingStr = spinsRemaining > 0 ? String(spinsRemaining - 1) : '∞';

    resourceManager.getController('inputOverlord').setText('autoplayCancelButton', spinsRemainingStr);
  }

  // this is called from WAIT_FOR_START state - this is where autoplay is done
  // or spin button press

  function playSpinSound() {
    let randomSpinSoundIndex = -1;
    let goes = 5;
    do {
      randomSpinSoundIndex = game.randomNumberBetween(0, _spinSounds.length - 1);
    } while (randomSpinSoundIndex === _lastRandomSpinSoundIndex && --goes > 0);
    soundManager.play(_spinSounds[randomSpinSoundIndex]);
    _lastRandomSpinSoundIndex = randomSpinSoundIndex;
  }

  function startGame() {
    // Do not allow the user to spin if the buy bonus present is up

    gameController.slamStopRequested = false;

    messageBus.postImmediate('gameController:startGame');

    let buyBonusPopUp = resourceManager.get('buyABonusContainer:buyBonusPopup');

    if (buyBonusPopUp.visible) return;

    playSpinSound();

    initNewSpin();

    var stakeController = resourceManager.getController('stakeController');
    let bpl = stakeController.BaseStake / stakeController.CurrentWinLineCount;

    gdk.startGame(
      {
        //numbers should came from the stake controller
        stake: stakeController.CurrentStake,
        numWinlines: stakeController.CurrentWinLineCount,
        bpl: bpl,
        metaData: {
          encore: gameData.encoreEnabled,
          buyABonus: false,
        },
      },
      function () {
        gdk.getNextGameOutcome(function () {});
      }
    );
  }

  function onAbortGame() {
    var slotMachine = GameSlotMachineFactory.getSlotMachine(0);

    // game aborted - reset reels to startup symbols
    for (var i = 0; i < slotMachine.reels.length; i++) {
      let reel = resourceManager.get('slotContainer:reelContainer:reel' + i);
      let startingSymbols = gameData.slotConfig.startingSymbols[i].symbols;
      let reelLength = gameData.slotConfig.startingSymbols[i].symbols.length;

      // Copy starting symbols from server
      for (var j = 0; j < reelLength; ++j) {
        reel.setReelSymbol(j, startingSymbols[j].value);

        // make sure the reel symbols are in the correct position
        reel.dropInitialSymbols(j, 1);
      }

      // just for completeness the off screen symbol
      // reel.dropInitialSymbols(3, 1);
    }

    // this basically means we now sit around and do nothing until
    // start getting messages from the connection
    console.log('gameController::switchState to WAITING_FOR_SERVER');
    gameController.stateMachine.switchState('WAITING_FOR_SERVER');
  }

  function doPayWins(payWinsEvent) {
    _payWinsEvent = payWinsEvent;
    _payWinsEvent.join();
    _numberOfPops++;

    // Add to cumulative total winnings
    _skipWin = false;
    _totalWinnings += _payWinsEvent.data.totalLineWinnings;
    _fullGameWinnings += _payWinsEvent.data.totalLineWinnings;

    gameController.canCelebrate = _totalWinnings > resourceManager.getController('stakeController').CurrentStake;

    // if (
    //   musicManager.currentBaseLevels === musicManager.ANTICIPATIONLEVEL ||
    //   musicManager.currentFSLevels === musicManager.FREESPINS_ANTICIPATIONLEVEL
    // ) {
    //   // anticipation tune playing - leave it playing until everything has finished
    // } else {
    //   // if (gameController.canCelebrate) {
    //   //   if (!freespins.inFreespins) {
    //   //     musicManager.fadeLevels(
    //   //       musicManager.SINGLEWINLEVEL,
    //   //       musicManager.fadeLevelTimeIn,
    //   //       musicManager.fadeLevelTimeOut,
    //   //       1,
    //   //       0
    //   //     );
    //   //   } else {
    //   //     musicManager.fadeFSLevels(
    //   //       musicManager.FREESPINS_LEVEL1,
    //   //       musicManager.fadeLevelTimeIn,
    //   //       musicManager.fadeLevelTimeOut
    //   //     );
    //   //   }
    //   // } else {
    //   // }
    // }

    console.log('gameController::switchState to PAYWINS');
    gameController.stateMachine.switchState('PAYWINS');
  }

  function preGameComplete(gameCompleteEvent) {
    doGameComplete();
  }

  function gambleResultEventDead(event) {
    // this is called when the big win from the gamble has finished
    // being presented
    // fire the event which should now finish the game
    messageBus.postImmediate('spinner:GambleCommandSent');
  }

  async function doGameComplete() {
    // i dont think we need this as we should only be updating the balance / credit meter
    // when ygg platform tells us
    // if (!_isPrePaid && !gameController.getIsRecovery()) {
    //   console.log('gameController:doGameComplete - update credit with', gameData.credit + _fullGameWinnings);
    //   gameData.creditMeter.set(gameData.credit + _fullGameWinnings);
    // }

    gameController.inBuyABonus = false;
    gameController.inBuyASuperBonus = false;

    musicManager.onGameEnd();

    // resourceManager.get("trail:TrailContainer").trailRunEnded();

    _fullGameWinnings = 0;
    console.log('gameController::switchState to END_GAME');
    gameController.stateMachine.switchState('END_GAME');

    // resourceManager.get('GuitaristView').stopEdsAudioSetter(false);
  }

  function autoplayStarted(autoplayData) {
    var spinsRemaining = autoplayManager.getRemainingRounds();
    var spinsRemainingStr = spinsRemaining >= 0 ? String(spinsRemaining) : 'X';

    resourceManager.getController('inputOverlord').setText('autoplayCancelButton', spinsRemainingStr);
  }

  function autoplayEnded(autoplayData) {
    resourceManager.getController('inputOverlord').setText('autoplayCancelButton', '');
    if (!autoplayManager.dialog.container.visible) {
      resourceManager.get('buttonContainer:buttonBar:autoplayButton:glow').visible = false;
    }
  }

  function onPopAndDropComplete(popAndDropCompleteEvent) {
    _popAndDropCompleteEvent = popAndDropCompleteEvent;

    // get us out of anticipation if needed
    if (
      musicManager.currentBaseLevels === musicManager.ANTICIPATIONLEVEL ||
      musicManager.currentFSLevels === musicManager.FREESPINS_ANTICIPATIONLEVEL
    ) {
      if (!freespins.inFreespins) {
        // have we reached the top of the trail?
        if (_bgTrail.isFull() !== true) {
          musicManager.fadeLevels(
            musicManager.SPINLEVEL,
            musicManager.fadeLevelTimeIn / 4,
            musicManager.fadeLevelTimeOut / 4,
            1,
            0
          );
        } else {
          musicManager.fadeLevels(
            musicManager.SINGLEWINLEVEL,
            musicManager.fadeLevelTimeIn / 4,
            musicManager.fadeLevelTimeOut / 4,
            1,
            0
          );
        }
      } else {
        musicManager.fadeFSLevels(
          musicManager.FREESPINS_LEVEL1, //
          musicManager.fadeLevelTimeIn / 4,
          musicManager.fadeLevelTimeOut / 4
        );
      }
    }

    // so we have 3 scenarios
    // win with 0 scatter wins
    // win with 1 scatter win
    // 0 win with 1 scatter win
    // all three scenarios, data.winnings will have a value in it

    if (popAndDropCompleteEvent.data.winnings > 0) {
      _popAndDropCompleteEvent.join();

      // SRB before we go and process the end of the drops
      // have we been awarded free spins via enough bonus symbols on the reels
      // because the win from the scatter is included in the base game trail
      // we can get scatter wins in basegame and in free spins
      let scatterWin = popAndDropCompleteEvent.data.finalBaseWinningsInitialScatterWinPreMult > 0;

      // before we check the scatterWin value - are we triggering free spins from the top of the trail?
      if (_bgTrail.isFull() === true) {
        let fsFromEggBeingAwarded = _popAndDropCompleteEvent.data.cascadeClimber?.outcome === 1; // outcome 1 = FS is being awarded
        let multiplierFromEggBeingAwarded = _popAndDropCompleteEvent.data.cascadeClimber?.outcome === 2; // outcome 1 = FS is being awarded
        if (fsFromEggBeingAwarded === true || multiplierFromEggBeingAwarded === true) {
          scatterWin = false;
          // this will need to be picked up later
          _scatterWinPostponed = true;
        }
      }

      if (scatterWin === true) {
        console.log('gameController::switchState to AWARD_SCATTER_WINS');
        gameController.stateMachine.switchState('AWARD_SCATTER_WINS');
        // make sure _totalWinnings contains the winnings with the scatter win also
        // waiting on value from server, as that should be capped im hoping
        _totalWinnings += popAndDropCompleteEvent.data.finalBaseWinningsInitialScatterWinPreMult;
      } else {
        // decide which state to go to, rather than having 1 state handle many things
        if (!freespins.inFreespins) {
          console.log('gameController::switchState to POP_AND_DROP_COMPLETE');
          gameController.stateMachine.switchState('POP_AND_DROP_COMPLETE');
        } else {
          if (!_maxWinShown && gameController.numberOfEggSymbolsOnReels() > 0) {
            // now do we have any eggs that need upgrading?
            if (gameController.anyEggsThatNeedUpgrading() === true) {
              console.log('gameController::switchState to UPGRADE_FS_EGG_MULTIPLIERS');
              gameController.stateMachine.switchState('UPGRADE_FS_EGG_MULTIPLIERS');
            } else {
              console.log('gameController::switchState to APPLY_FS_EGG_MULTIPLIERS');
              gameController.stateMachine.switchState('APPLY_FS_EGG_MULTIPLIERS');
            }
          } else {
            if (_startAnticipationDelayFromReel != -2 && gameController.numberOfBonusSymbolsOnReels() < 3) {
              // we have missed out on retrigger, and no other positive outcomes other than wins?
              console.log('gameController::switchState to JACK_NEGATIVE_ANIM');
              gameController.stateMachine.switchState('JACK_NEGATIVE_ANIM');
            } else {
              console.log('gameController::switchState to POP_AND_DROP_COMPLETE_FS');
              gameController.stateMachine.switchState('POP_AND_DROP_COMPLETE_FS');
            }
          }
        }
      }
    } else {
      if (freespins.inFreespins) {
        if (_startAnticipationDelayFromReel != -2 && gameController.numberOfBonusSymbolsOnReels() < 3) {
          // we have missed out on retrigger, and no other positive outcomes other than wins?
          _popAndDropCompleteEvent.join();
          console.log('gameController::switchState to JACK_NEGATIVE_ANIM_NO_WIN');
          gameController.stateMachine.switchState('JACK_NEGATIVE_ANIM_NO_WIN');
        }
      }
    }
  }

  function onDropEvent(dropEvent) {
    _dropEvent = dropEvent;
    _dropEvent.join();

    _specialEvent = _dropEvent?.data?.specialReward?.type;

    _bonusSymsDropComplete = false;

    console.log('gameController::switchState to POP_SYMBOLS');
    gameController.stateMachine.switchState('POP_SYMBOLS');
  }

  function onModifierEvent(modifierEvent) {
    _modifierEventTriggered = true;
  }

  function onExtraSpinsRemaining(event) {}

  async function onDropOldSymbolsComplete(droppedReel) {
    _dropsRemaining--;

    if (_dropsRemaining === 0) {
      // we should now be able to start the anticipation loop anims playing
      // and wait a short amount of time before dropping new symbols

      gameController.startExistingAnticipationSymbolsLooping();
      _dropsRemaining = 6; // setup just before the drops are made
      const delays = slotMachine.createDropDelaysForNewSymbols(_colossalData, _tempPopData);
      console.log('drop delays for new are', delays);
      for (let i = 0; i < _tempPopData.length; i++) {
        gameData.reels[i].dropNewSymbols(delays[i], _tempPopData[i], onDropComplete);
      }
    }
  }

  async function onDropComplete(droppedReel) {
    _dropsRemaining--;

    if (
      musicManager.currentBaseLevels !== musicManager.ANTICIPATIONLEVEL &&
      musicManager.currentFSLevels !== musicManager.FREESPINS_ANTICIPATIONLEVEL
    ) {
      // only play these when not anticipating?
      gameController.playRandomDropFinishedSound();
    }

    if (_dropsRemaining === 0) {
      await gameController.startAllLandAnimsDetection();

      // this should be here but we need to see if the winnings meter is at max cap
      // or extra checks to see if this is the last part of the game
      if (_winningsMeterCapped === true && _maxWinShown === false) {
        await showMaxWinPopup();
      }

      // before we clear the colossal data, do we have any that need converting?
      const weHaveColossal = gameController.doWeHaveColossals(_colossalData);
      if (weHaveColossal === true && _dropEvent.data.hasCascades === true) {
        // only convert into smaller ones if we have wins
        _colossalConvertTaskToLeave = _dropEvent;
        console.log('gameController::switchState to CONVERT_COLOSSAL_TO_SMALL');
        gameController.stateMachine.switchState('CONVERT_COLOSSAL_TO_SMALL');
      } else {
        // we dont have to reset here
        // we need to keep the data for calculating delays when spin is pressed
        // _colossalData = slotMachine.resetColossalData();
        console.log('gameController::switchState to WAITING_FOR_SERVER');
        gameController.stateMachine.switchState('WAITING_FOR_SERVER');
        _dropEvent.leave();
      }
    }
  }

  function onReelToFrespinsBarComplete() {
    _reelToFrespinsBarFlying--;
    if (_reelToFrespinsBarFlying === 0) {
      // Move onto next phase
      _allPopsComplete = true;
    }
  }

  function onFeatureAnnounced(task) {
    _featureAwarded = true;

    // resourceManager.get('GuitaristView').stopEdsAudioSetter(false);
  }

  function onFeatureEnded() {
    _featureAwarded = false;

    // resourceManager.get('GuitaristView').stopEdsAudioSetter(false);
  }

  function update(delta, time) {
    // Store time for wobble
    _currentTime = time;

    this.stateMachine.update();
  }

  function dimAllReels(dim) {
    for (var i = 0; i < reelManager.reels.length; i++) {
      reelManager.reels[i].dimAllSymbols(dim, 0x666666);
    }
  }

  function wobbleSymbol(symbol, amount, reel) {
    var prog = (_currentTime % 1000) / 1000 - reel * 0.1;
    var pos = Math.sin(Math.PI * 2 * prog) * amount;
    // TODO - decide if we still need to do this.
    //  symbol.position.set(0,pos);
  }

  function globalHelperGetBaseStake() {
    return resourceManager.getController('stakeController').getBaseStake();
  }

  function globalHelperGetStake() {
    let stake = resourceManager.getController('stakeController').BaseStake;
    if (gameController.inBuyASuperBonus) {
      stake *= 300;
    } else if (gameController.inBuyABonus) {
      stake *= 100;
    }

    return stake;
  }

  //define gameController
  gameController = Object.create(spinFunctions);
  Object.defineProperties(gameController, {
    startGame: { value: startGame },
    hideGameLogo: { value: hideGameLogo },
    showGameLogo: { value: showGameLogo },
    resetWinnings: { value: resetWinnings },
    initNewSpin: { value: initNewSpin },
    globalHelperGetBaseStake: { value: globalHelperGetBaseStake },
    globalHelperGetStake: { value: globalHelperGetStake },
    slamStopRequested: {
      get: function () {
        return _slamStopRequested;
      },
      set: function (value) {
        _slamStopRequested = value;
      },
    },
    maxWinShown: {
      get: function () {
        return _maxWinShown;
      },
      set: function (value) {
        _maxWinShown = value;
      },
    },
    fullGameWinnings: {
      get: function () {
        return _fullGameWinnings;
      },
      set: function (value) {
        _fullGameWinnings = value;
      },
    },
    anticipationSymbolsLanding: {
      get: function () {
        return _anticipationSymbolsLanding;
      },
      set: function (value) {
        _anticipationSymbolsLanding = value;
      },
    },
    anticipationSymbolsLanded: {
      get: function () {
        return _anticipationSymbolsLanded;
      },
      set: function (value) {
        _anticipationSymbolsLanded = value;
      },
    },
    bonusSymbolsLanded: {
      get: function () {
        return _bonusSymbolsLanded;
      },
      set: function (value) {
        _bonusSymbolsLanded = value;
      },
    },
    startAnticipationDelayFromReel: {
      get: function () {
        return _startAnticipationDelayFromReel;
      },
    },
    allLandAnimsFinished: {
      get: function () {
        return _allLandAnimsFinished;
      },
    },
    colossalData: {
      get: function () {
        return _colossalData;
      },
      set: function (value) {
        _colossalData = value;
      },
    },
    totalWinnings: {
      get: function () {
        return _totalWinnings;
      },
      set: function (value) {
        _totalWinnings = value;
      },
    },
    doGameComplete: { value: doGameComplete },
    canEnableSkip: { value: canEnableSkip },
    isFeatureAwarded: {
      get: function () {
        return _featureAwarded;
      },
    },
    dimAllReels: { value: dimAllReels },
    rng: { value: _rng },
    inBuyABonus: {
      get: function () {
        return _inBuyABonus;
      },
      set: function (value) {
        _inBuyABonus = value;
      },
    },
    inBuyASuperBonus: {
      get: function () {
        return _inBuyASuperBonus;
      },
      set: function (value) {
        _inBuyASuperBonus = value;
      },
    },
    gambleModeIndex: {
      get: function () {
        return _gambleModeIndex;
      },
      set: function (value) {},
    },
    switchGambleMode: { value: switchGambleMode },
    gambleMode: {
      get: function () {
        return _gambleMode;
      },
      set: function (value) {
        _gambleMode = value;
      },
    },
  });

  gameController.resetSymbolCallbackFired = function () {
    _symbolCallbackFired = [];
  };

  gameController.cancelAutoplay = function () {
    resourceManager.getController('autoplayController').cancel();
  };

  /**
   * Set up the win flash animations
   *
   * To position this, use your symbol sizes and then move the reelsParticleLayer in layout
   *
   */
  gameController.setupSymbolDisappearAnims = function () {
    const numReels = 6;
    const numSymbols = 5;

    for (var i = 0; i < numReels; i++) {
      var rowAnims = [];
      var wildRowAnims = [];

      for (var j = 0; j < numSymbols; j++) {
        let posX = 130 * i + 50; // 50 is x pos of 1st reel
        let posY = 110 * j + 75; // 75 is y pos of 1st reel

        // const parentName = 'reelsParticleLayer';
        // const parentName = 'slotContainer:reelContainer:foregroundReelSymbols';
        const parentName = 'slotContainer:foregroundReelSymbols';

        var movie = resourceManager.createObject('movie', 'symbolDisappear_' + i + '_' + j, parentName, {
          definition: 'symbolFlash_md',
          x: posX,
          y: posY,
          anchor: 0.5,
          scale: 2,
          loop: false,
        });

        // again dont keep them all on the scene graph
        movie.parent.removeChild(movie);

        // var wild = resourceManager.createObject('movie', 'wildBlast' + i + '_' + j, 'reelsParticleLayer', {
        //   definition: 'wildBlast',
        //   x: posX,
        //   y: posY,
        //   anchor: 0.5,
        //   scale: 2,
        //   loop: false,
        // });

        movie.gotoAndStop(0);
        // wild.gotoAndStop(0);

        rowAnims.push(movie);
        // wildRowAnims.push(wild);
      }

      _symbolDisappearAnims.push(rowAnims);
      // _wildBlastAnims.push(wildRowAnims);
    }
  };

  gameController.getExplosionAnims = function () {
    return _symbolDisappearAnims;
  };

  gameController._receivedResponse = false;

  // State Machine //

  StateMachine.Create(gameController);

  gameController.stateMachine.addState('WAITING_FOR_SERVER', function () {});

  gameController.stateMachine.addState('WAIT_FOR_START', function () {
    _isGameIdle = true;

    if (gameController.phase.once()) {
      gameController.startRandomEggWobbleTimer();
      resourceManager.getController('inputOverlord').setState('enabled'); // from BGF
      resourceManager.getController('autoplayController').checkLimits();
    }
    if (gameController.phase.hold()) {
      if (!resourceManager.getController('autoplayController').LimitPopupOpen) {
        gameController.phase.step();
      }
    }
    if (gameController.phase.hold()) {
      // Waiting for player to do something
      if (autoplayManager.isAutoplayEnabled()) {
        if (autoplayManager.AP.getFields()['numberOfRounds'].currentValue !== autoplayManager.AP.roundsRemaining()) {
          var timeToNext = 500;
          resourceManager.getController('autoplayController').timeToNextAutoplay = timeToNext;
          gameController.phase.step();
        }
      }
    }
    if (gameController.phase.timed(resourceManager.getController('autoplayController').timeToNextAutoplay)) {
      if (!autoplayManager.isAutoplayEnabled()) {
        gameController.phase.reset();
      }
    }
    if (gameController.phase.once()) {
      startGame();
    }
  });

  gameController.startRandomEggWobbleTimer = function () {
    gameController.stopRandomEggWobbleTimer();
    if (freespins.inFreespins !== true) {
      let randomDelayInMS = game.randomNumberBetween(2, 3) * 1000;
      const timer = timerManager.addTimer(randomDelayInMS, undefined, () => {
        gameController.playEggWobbleIfRequired();
      });
      // console.log('starting egg wobble timer with ', randomDelayInMS);
      _eggWobbleTimer = timer;
    }
  };

  gameController.stopRandomEggWobbleTimer = function () {
    // console.log('stopping egg wobble timer');
    if (_eggWobbleTimer) {
      timerManager.stop(_eggWobbleTimer);
      // console.log('stopped egg wobble timer');
      _eggWobbleTimer = null;
    }
  };

  gameController.playEggWobbleIfRequired = function (fromStart = false) {
    if (_isGameIdle || fromStart === true) {
      const random = fromStart ? game.randomNumberBetween(0, 3) : game.randomNumberBetween(0, 2);
      // shouldnt need to worry about it currently playing
      if (random === 0) {
        soundManager.play('eggTease');
        _bgTrail.playEggWobble();
      }
      if (_isGameIdle) {
        this.startRandomEggWobbleTimer();
      }
    }
  };

  gameController.initialDropComplete = function (reelID) {
    --_initialDropping;
  };

  gameController.stateMachine.addState('CLEAR_REELS', function () {
    // when reels have cleared we can drop in new positions
    // clear reels has a callback to reduce reelsDropping count
    if (gameController.phase.enter()) {
      _initialDropping = gameData.reels.length;

      gameController.hideOverlay();
    }

    // TODO 23/05/22 this needs to hold until all initial reels are dropped AND the spin task has been received
    if (gameController.phase.hold()) {
      if (_initialDropping === 0) {
        gameController.phase.step();
      }
    }

    // drop intial symbols needs to have finished before we do spin task leave and the symbols should all have landed
    if (gameController.phase.once()) {
      const license = gameData.license.toUpperCase();
      if (license === 'DE') {
        console.log('gameController::switchState to DELAY_DROP_INITIAL_SYMBOLS');
        gameController.stateMachine.switchState('DELAY_DROP_INITIAL_SYMBOLS');
      } else {
        console.log('gameController::switchState to DROP_INITIAL_SYMBOLS');
        gameController.stateMachine.switchState('DROP_INITIAL_SYMBOLS');
      }
    }
  });

  gameController.playRandomDropFinishedSound = function () {
    let randomIndex = -1;
    let goes = 5;
    do {
      randomIndex = game.randomNumberBetween(0, _dropFinishedSounds.length - 1);
    } while (randomIndex === _lastRandomDropFinishedSoundIndex && --goes > 0);
    soundManager.play(_dropFinishedSounds[randomIndex]);
    _lastRandomDropFinishedSoundIndex = randomIndex;
  };

  gameController.startAllLandAnimsDetection = async function () {
    _allLandAnimsFinished = false;

    const promises = [];
    for (let i = 0; i < _landedAnimsPlayingData.length; i++) {
      for (let j = 0; j < _landedAnimsPlayingData[i].length; j++) {
        if (_landedAnimsPlayingData[i][j]) {
          console.log('stop looping movies');
          if (_landedAnimsPlayingData[i][j].landAnim) {
            _landedAnimsPlayingData[i][j].landAnim.stopLooping = true;
          }
          promises.push(_landedAnimsPlayingData[i][j].landAnimPromise);
        }
      }
    }

    await Promise.all(promises);

    _allLandAnimsFinished = true;
  };

  gameController.stateMachine.addState('DELAY_DROP_INITIAL_SYMBOLS', function () {
    if (gameController.phase.enter()) {
      // should we recalculate the delay based on minGameTime
    }

    if (gameController.phase.timed(250)) {
    }

    if (gameController.phase.once()) {
      console.log('gameController::switchState to DROP_INITIAL_SYMBOLS');
      gameController.stateMachine.switchState('DROP_INITIAL_SYMBOLS');
    }
  });

  gameController.stateMachine.addState('DROP_INITIAL_SYMBOLS', function () {
    if (gameController.phase.hold()) {
      // don't proceed unless we receive the spin task
      // this is populated via the onSpinEvent in spinFunctions.js
      if (gameController.spinTask !== undefined) {
        gameController.phase.step();
      }
    }

    if (gameController.phase.once()) {
      if (gameController.spinTask.data.localRng) {
        gameController.rng.seed(gameController.spinTask.data.localRng);
      }

      _isPrePaid = gameController.spinTask?.data.isPrePaidGame;

      _reelsSpinning = [true, true, true, true, true, true];
      _symbolCallbackFired = [];

      logoIdleTimeline.pause();

      let _positions = gameController.spinTask.data.resultPanel.reelList.map(function (reel, index) {
        return reel.symbols.map(function (curr) {
          return curr.value;
        });
      });

      // calculate whether we display landing symbols
      gameController.calcLandingAnims(gameController.spinTask);
      gameController.calcAnticipation(gameController.spinTask);

      // now drop the symbols in
      // so colossals should only come in 50% of the time if there is a win
      // 25% of the time if no win
      const chance = gameController.spinTask.data.totalWinnings ? 50 : 25;
      const convertToColossals = _startAnticipationDelayFromReel === -2 ? true : false; //gameController.rng.passChance(chance);

      _colossalData = slotMachine.dropInitialSymbols(_positions, null, convertToColossals);
    }

    if (gameController.phase.once()) {
      gameController._receivedResponse = true; // this allows slam stop
    }

    // don't proceed until all reels have finished spinning
    if (gameController.phase.hold()) {
      // check for any reels still spinning
      var spinComplete = true;
      for (var spinningIdx = 0; spinningIdx < _reelsSpinning.length; spinningIdx++) {
        spinComplete = spinComplete && !_reelsSpinning[spinningIdx];
      }

      if (spinComplete) {
        gameController.phase.step();
        gameController._receivedResponse = false;
      }
    }

    if (gameController.phase.once()) {
      // yes its and async, but in the next hold section, we wait for the var to be set
      // to true
      gameController.startAllLandAnimsDetection();
    }

    // wait for all landing anims to finish playing
    if (gameController.phase.hold()) {
      // all landing anims finished - hide them away
      if (_allLandAnimsFinished) {
        gameController.phase.step();
      }
    }

    if (gameController.phase.once()) {
      // do we have any colossals on the reels?
      // if so these need converting back into small ones before we do anything
      const weHaveColossal = gameController.doWeHaveColossals(_colossalData);
      if (weHaveColossal === true && gameController.spinTask.data.hasCascades === true) {
        // only convert into smaller ones if we have wins
        _colossalConvertTaskToLeave = gameController.spinTask;
        console.log('gameController::switchState to CONVERT_COLOSSAL_TO_SMALL');
        gameController.stateMachine.switchState('CONVERT_COLOSSAL_TO_SMALL');
      } else {
        console.log('gameController::switchState to WAITING_FOR_SERVER');
        gameController.stateMachine.switchState('WAITING_FOR_SERVER');

        if (gameController.spinTask) {
          gameController.spinTask.leave();
        }
      }
    }
  });

  gameController.doWeHaveColossals = function (colossalData) {
    let weHaveColossal = false;
    if (colossalData) {
      for (let i = 0; i < colossalData.length && !weHaveColossal; i++) {
        for (let j = 0; j < colossalData[i].length && !weHaveColossal; j++) {
          if (colossalData[i][j] !== null) {
            weHaveColossal = true;
          }
        }
      }
    }
    return weHaveColossal;
  };

  gameController.stateMachine.addState('CONVERT_COLOSSAL_TO_SMALL', function () {
    if (gameController.phase.once()) {
      // convert all colossals
      slotMachine.convertColossalsIntoSmall(_colossalData);
    }

    if (gameController.phase.hold()) {
      // wait for all to be converted
      if (slotMachine.isconvertingColossalsIntoSmall() !== true) {
        // must of finished
        gameController.phase.step();
      }
    }

    if (gameController.phase.once()) {
      // this will reset the data
      _colossalData = slotMachine.resetColossalData();

      console.log('gameController::switchState to WAITING_FOR_SERVER');
      gameController.stateMachine.switchState('WAITING_FOR_SERVER');

      if (_colossalConvertTaskToLeave) {
        _colossalConvertTaskToLeave.leave();
      }
      _colossalConvertTaskToLeave = null;
    }
  });

  // handle the anims on landing - cascadeInfiniReels calls this callback
  // then we match up if it's a valid bonus symbol to play anim/sound
  gameController.onSymbolLandedCallback = function (landedReel, landedRow) {
    let ignore = false;

    // check that we have't already fired this callback ( can be retriggered doing a slam stop )
    for (let i = 0; i < _symbolCallbackFired.length && !ignore; i++) {
      const firedReel = _symbolCallbackFired[i][0];
      const firedRow = _symbolCallbackFired[i][1];

      // if we've already fired this callback don't do it again
      if (landedReel === firedReel && landedRow === firedRow) {
        ignore === true;
      }
    }

    if (!ignore) {
      // this ideally needs splitting into 2 parts
      // probably but

      let bonusLanded = false;
      let anticipationSymbolLanded = false;

      // we've got here so this must be the first time we've fired this callback - add to array
      _symbolCallbackFired.push([landedReel, landedRow]);

      // because we are using the same land anim vars to loop anticipation symbols and wait for them,
      // we may have an issue where we arent actually playing a land anim. calc land anims didnt setup the data
      // for us, so here check for that and populate just incase
      const anticipationConfig = resourceManager.getConfiguration().anticipationConfig;
      // landAnimData doesnt exist here!!
      // so check it out on the reels
      if (gameData.reels[landedReel].symbolData[landedRow].symbolId === anticipationConfig.requiredSymbol) {
        // a anticipation symbol has landed
        anticipationSymbolLanded = true;
      }

      if (anticipationSymbolLanded === true && !_landedAnimsPlayingData[landedReel][landedRow]) {
        // anticipation symbol has landed but we arent playing a land anim
        // just create the data object for now

        // if we arent to play landing anims
        // why is this needed?
        // it gets us past the landAnim check
        _landedAnimsPlayingData[landedReel][landedRow] = {
          ignore: true, // yuck - dont play the anim further down
          reel: landedReel,
          row: landedRow,
          symbolId: anticipationConfig.requiredSymbol,
          landAnimPromise: null,
          looping: false,
        };
      }

      // now continue
      landAnimData = _landedAnimsPlayingData[landedReel][landedRow];

      // look to see if we are to play a land anim here
      if (landAnimData !== null) {
        const data = {
          symbolIndex: landedRow,
          symbolId: landAnimData.symbolId,
          loop: false,
          landAnim: null,
          fromFrame: 0,
        };

        // tbh we arent that super interested in bonus symbols other than the anticipation
        // side of it
        // but left all this here
        const bonusID = resourceManager.getConfiguration().symbols['Bonus'].ID;
        if (landAnimData.symbolId === bonusID) {
          // a bonus symbol has landed
          bonusLanded = true;
        }

        const numRequiredSymbols = freespins.inFreespins
          ? anticipationConfig.numRequiredSymbolsFS
          : anticipationConfig.numRequiredSymbols;
        if (anticipationSymbolLanded && _anticipationSymbolsLanded >= numRequiredSymbols - 1) {
          // we want to loop the anims from now, rather than just once
          // but that will effect the bit of code later on where we are waiting for
          // land anims to finish playing
          // we need to set a flag which will stop the anims basically
          data.loop = true;
          // we also need to find a previous looping bonus
          // if we dont have one, then it means this is the 1st looping bonus,
          // we start from 0
          // and we tell the others to stop and start looping
          // we will also be getting to a point where we wont be playing a land anim on the anticipation
          // symbols, so we also need to add a check for that
          const ignoreData = {
            reel: landedReel,
            row: landedRow,
          };

          // check to see if anticipation is actually needed
          if (_startAnticipationDelayFromReel !== -2) {
            landAnimData.ignore = false;
            gameController.startExistingAnticipationSymbolsLooping(ignoreData, landedReel);

            for (let i = 0; i <= landedReel; i++) {
              for (let j = 0; j < _landedAnimsPlayingData[i].length; j++) {
                if (
                  _landedAnimsPlayingData[i][j] &&
                  _landedAnimsPlayingData[i][j].symbolId === anticipationConfig.requiredSymbol
                ) {
                  if (_landedAnimsPlayingData[i][j].looping === true) {
                    // already looping which is good and we dont need to do anything else other than grab the frame
                    data.fromFrame = _landedAnimsPlayingData[i][j].landAnim.currentFrame;
                  } else {
                    if (_landedAnimsPlayingData[i][j].landAnim) {
                      // this isnt looping, so we need to stop it and restart it
                      // but if we stop, will it call the onComplete?
                      // we call it manually
                      _landedAnimsPlayingData[i][j].landAnim.stop();
                      _landedAnimsPlayingData[i][j].landAnim.onComplete();
                      const newData = {
                        symbolIndex: j,
                        symbolId: anticipationConfig.requiredSymbol,
                        loop: true,
                        landAnim: null,
                        fromFrame: 0,
                      };
                      _landedAnimsPlayingData[i][j].landAnimPromise = reelManager.reels[i].playLandAnim(newData);
                      _landedAnimsPlayingData[i][j].landAnim = newData.landAnim;
                      _landedAnimsPlayingData[i][j].looping = newData.loop;
                    } else {
                      // we have an anticipation symbol landed, but no land anim
                      // not sure we need to do anything about it right now
                    }
                  }
                }
              }
            }
          }
        }

        // land anim required
        // ask the reel to play the land anim for this symbol at position
        if (!landAnimData.ignore) {
          //
          landAnimData.landAnimPromise = reelManager.reels[landedReel].playLandAnim(data);
          landAnimData.landAnim = data.landAnim;
          landAnimData.looping = data.loop;
        } else {
          _landedAnimsPlayingData[landedReel][landedRow] = null;
        }
      }

      if (bonusLanded) {
        if (!gameData.reels[landedReel].slamStopRequested) {
          gameController.playBonusSymbolLandedSound();
        }
        _bonusSymbolsLanded++;
      }

      if (anticipationSymbolLanded) {
        _anticipationSymbolsLanded++;
      }
    }
  };

  gameController.playBonusSymbolLandedSound = function () {
    let index = _bonusSymbolsLanded;
    if (index > _spinBonusSounds.length - 1) {
      index = _spinBonusSounds.length - 1;
    }
    soundManager.play(_spinBonusSounds[index]);
  };

  // we are still using _landedAnimsPlayingData
  // this allows us to wait for these anims to finish at the end of drops
  // same way we would wait for landing anims to finish on other symbols
  gameController.startExistingAnticipationSymbolsLooping = function (
    ignoreData,
    uptoReel = _landedAnimsPlayingData.length
  ) {
    var slotMachine = GameSlotMachineFactory.getSlotMachine(0);
    const skipAnticipationTune = false; //slotMachine.slamStopRequested
    if (!skipAnticipationTune) {
      if (!freespins.inFreespins) {
        musicManager.fadeLevels(
          musicManager.ANTICIPATIONLEVEL,
          musicManager.fadeLevelTimeIn / 4,
          musicManager.fadeLevelTimeOut / 4,
          1,
          0
        );
      } else {
        musicManager.fadeFSLevels(
          musicManager.FREESPINS_ANTICIPATIONLEVEL,
          musicManager.fadeLevelTimeIn / 4,
          musicManager.fadeLevelTimeOut / 4
        );
      }
    }

    const anticipationConfig = resourceManager.getConfiguration().anticipationConfig;
    for (let i = 0; i < uptoReel; i++) {
      for (let j = 0; j < _landedAnimsPlayingData[i].length; j++) {
        if (ignoreData && ignoreData.reel === i && ignoreData.row === j) {
          continue;
        }

        if (!_landedAnimsPlayingData[i][j]) {
          if (reelManager.reels[i].symbolData[j].symbolId === anticipationConfig.requiredSymbol) {
            _landedAnimsPlayingData[i][j] = {
              reel: i,
              row: j,
              symbolId: anticipationConfig.requiredSymbol,
              landAnimPromise: null,
              looping: false,
            };
            // this bonus symbol already on the reels needs to start looping
            // these could already be playing
            // if thats the case, _landedAnimsPlayingData[i][j] will have valid data in it
            const newData = {
              symbolIndex: j,
              symbolId: anticipationConfig.requiredSymbol,
              loop: true,
              landAnim: null,
              fromFrame: 0,
            };
            _landedAnimsPlayingData[i][j].landAnimPromise = reelManager.reels[i].playLandAnim(newData);
            _landedAnimsPlayingData[i][j].landAnim = newData.landAnim;
            _landedAnimsPlayingData[i][j].looping = newData.loop;
          }
        }
      }
    }
  };

  gameController.onSymbolDroppedCallback = function (droppedReel, droppedRow, whatSymbols) {
    // should this call 2 functions, 1 for bonus symbols and 1 for anticipation?
    // probably but
    let ignore = false;

    // check that we have't already fired this callback ( can be retriggered doing a slam stop )
    for (let i = 0; i < _symbolCallbackFired.length && !ignore; i++) {
      const firedReel = _symbolCallbackFired[i][0];
      const firedRow = _symbolCallbackFired[i][1];

      // if we've already fired this callback don't do it again
      if (droppedReel === firedReel && droppedRow === firedRow) {
        ignore === true;
      }
    }

    if (!ignore) {
      let bonusLanded = false;
      let anticipationSymbolLanded = false;

      // we've got here so this must be the first time we've fired this callback - add to array
      _symbolCallbackFired.push([droppedReel, droppedRow]);

      // because we are using the same land anim vars to loop anticipation symbols and wait for them,
      // we may have an issue where we arent actually playing a land anim. calc land anims didnt setup the data
      // for us, so here check for that and populate just incase
      const anticipationConfig = resourceManager.getConfiguration().anticipationConfig;
      // landAnimData doesnt exist here!!
      // so check it out on the reels
      if (
        gameData.reels[droppedReel].symbolData[droppedRow].symbolId === anticipationConfig.requiredSymbol &&
        gameData.reels[droppedReel].symbolSprites[droppedRow].droppingInFromOff === true
      ) {
        // a anticipation symbol has landed
        anticipationSymbolLanded = true;
      }

      if (anticipationSymbolLanded === true && !_landedAnimsPlayingData[droppedReel][droppedRow]) {
        // anticipation symbol has landed but we arent playing a land anim
        // just create the data object for now
        _landedAnimsPlayingData[droppedReel][droppedRow] = {
          ignore: true,
          reel: droppedReel,
          row: droppedRow,
          symbolId: anticipationConfig.requiredSymbol,
          landAnimPromise: null,
          looping: false,
        };
      }

      landAnimData = _landedAnimsPlayingData[droppedReel][droppedRow];

      // look to see if we are to play a land anim here
      if (landAnimData !== null) {
        const data = {
          symbolIndex: droppedRow,
          symbolId: landAnimData.symbolId,
          loop: false,
          landAnim: null,
          fromFrame: 0,
        };

        // tbh we arent that super interested in bonus symbols other than the anticipation
        // side of it
        // but left all this here
        const bonusID = resourceManager.getConfiguration().symbols['Bonus'].ID;
        if (landAnimData.symbolId === bonusID) {
          // a bonus symbol has landed
          bonusLanded = true;
        }

        const numRequiredSymbols = freespins.inFreespins
          ? anticipationConfig.numRequiredSymbolsFS
          : anticipationConfig.numRequiredSymbols;
        if (anticipationSymbolLanded && _anticipationSymbolsLanded >= numRequiredSymbols - 1) {
          // we want to loop the anims from now, rather than just once
          // but that will effect the bit of code later on where we are waiting for
          // land anims to finish playing
          // we need to set a flag which will stop the anims basically
          data.loop = true;
          // we also need to find a previous looping bonus
          // if we dont have one, then it means this is the 1st looping bonus,
          // we start from 0
          // and we tell the others to stop and start looping
          // we will also be getting to a point where we wont be playing a land anim on the anticipation
          // symbols, so we also need to add a check for that

          // we need to go through the bonus symbols already on the reels and start those looping
          // if we look for them, and cross reference _landedAnimsPlayingData
          // we should be able to know if they need to be played

          // check to see if anticipation is actually needed
          if (_startAnticipationDelayFromReel !== -2) {
            landAnimData.ignore = false;
            gameController.startExistingAnticipationSymbolsLooping();

            for (let i = 0; i <= droppedReel; i++) {
              for (let j = 0; j < _landedAnimsPlayingData[i].length; j++) {
                if (
                  _landedAnimsPlayingData[i][j] &&
                  _landedAnimsPlayingData[i][j].symbolId === anticipationConfig.requiredSymbol
                ) {
                  if (_landedAnimsPlayingData[i][j].looping === true) {
                    // already looping which is good and we dont need to do anything else other than grab the frame
                    data.fromFrame = _landedAnimsPlayingData[i][j].landAnim.currentFrame;
                  } else {
                    if (_landedAnimsPlayingData[i][j].landAnim) {
                      // this isnt looping, so we need to stop it and restart it
                      // but if we stop, will it call the onComplete?
                      // we call it manually
                      _landedAnimsPlayingData[i][j].landAnim.stop();
                      _landedAnimsPlayingData[i][j].landAnim.onComplete();
                      const newData = {
                        symbolIndex: j,
                        symbolId: anticipationConfig.requiredSymbol,
                        loop: true,
                        landAnim: null,
                        fromFrame: 0,
                      };
                      _landedAnimsPlayingData[i][j].landAnimPromise = reelManager.reels[i].playLandAnim(newData);
                      _landedAnimsPlayingData[i][j].landAnim = newData.landAnim;
                      _landedAnimsPlayingData[i][j].looping = newData.loop;
                    } else {
                      // we have an anticipation symbol landed, but no land anim
                      // not sure we need to do anything about it right now
                    }
                  }
                }
              }
            }
          }
        }

        // land anim required
        // ask the reel to play the land anim for this symbol at position
        // look to see if we have already played an anim
        if (!landAnimData.landAnimPromise && !landAnimData.ignore) {
          landAnimData.landAnimPromise = reelManager.reels[droppedReel].playLandAnim(data);
          landAnimData.landAnim = data.landAnim;
          landAnimData.looping = data.loop;
        }

        if (landAnimData.ignore) {
          _landedAnimsPlayingData[droppedReel][droppedRow] = null;
        }
      }

      if (
        bonusLanded && //
        whatSymbols !== 'old' &&
        gameData.reels[droppedReel].symbolSprites[droppedRow].droppingInFromOff
      ) {
        gameController.playBonusSymbolLandedSound();
        _bonusSymbolsLanded++;
      }

      if (anticipationSymbolLanded && gameData.reels[droppedReel].symbolSprites[droppedRow].droppingInFromOff) {
        _anticipationSymbolsLanded++;
      }
    }
  };

  gameController.reparentSymbolsToOriginalParents = function () {
    // for (let r = 0; r < gameData.reels.length; r++) {
    //   gameData.reels[r].reparentSymbolsToOriginalParents();
    // }
  };

  // Here we amend the layering for any oversized symbols so they're always on top
  gameController.parentAllOversizedSymbols = function () {
    for (let r = 0; r < gameData.reels.length; r++) {
      gameData.reels[r].parentAllOversizedSymbols();
    }
  };

  gameController.calcLandingAnimsForDrops = function (reels) {
    const bonusID = resourceManager.getConfiguration().symbols['Bonus'].ID;

    // const symbolIDsWithLandAnims = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
    const symbolIDsWithLandAnims = [];

    _landedAnimsPlayingData = [];

    for (let reelID = 0; reelID < reels.length; reelID++) {
      _landedAnimsPlayingData[reelID] = [];
      for (let i = 0; i < 5; i++) {
        _landedAnimsPlayingData[reelID][i] = null;

        const symbolId = reels[reelID].symbolData[i].symbolId;

        if (symbolId === bonusID && reels[reelID].symbolSprites[i].droppingInFromOff === true) {
          // _landedAnimsPlayingData[reelID][i] = {
          //   reel: reelID,
          //   row: i,
          //   symbolId: bonusID,
          //   landAnimPromise: null,
          //   looping: false,
          // };
        } else {
          if (symbolIDsWithLandAnims.indexOf(symbolId) !== -1) {
            // _landedAnimsPlayingData[reelID][i] = {
            //   reel: reelID,
            //   row: i,
            //   symbolId: symbolId,
            //   landAnimPromise: null,
            //   looping: false,
            // };
          }
        }
      }
    }

    return _landedAnimsPlayingData;
  };

  gameController.calcLandingAnims = function (spinTask) {
    const bonusID = resourceManager.getConfiguration().symbols['Bonus'].ID;
    const symbolIDsWithLandAnims = [];

    _landedAnimsPlayingData = [];

    for (let reelID = 0; reelID < reelManager.reels.length; reelID++) {
      _landedAnimsPlayingData[reelID] = [];
      for (let i = 0; i < 5; i++) {
        _landedAnimsPlayingData[reelID][i] = null;
        const symbolId = spinTask.data.resultPanel.reelList[reelID].symbols[i].value;

        if (symbolId === bonusID) {
          // _landedAnimsPlayingData[reelID][i] = {
          //   reel: reelID,
          //   row: i,
          //   symbolId: bonusID,
          //   landAnimPromise: null,
          //   looping: false,
          // };
        } else {
          // if (symbolIDsWithLandAnims.indexOf(symbolId) !== -1) {
          //   _landedAnimsPlayingData[reelID][i] = {
          //     reel: reelID,
          //     row: i,
          //     symbolId: symbolId,
          //     landAnimPromise: null,
          //     looping: false,
          //   };
          // }
        }
      }
    }

    return _landedAnimsPlayingData;
  };

  gameController.slamStop = function () {
    // is this enough?
    gameController.slamStopRequested = true;
    gameController.startAllLandAnimsDetection();
  };

  // just works out which reel to start the slow down delays from
  gameController.calcAnticipation = function (spinTask) {
    const anticipationConfig = resourceManager.getConfiguration().anticipationConfig;

    _anticipationSymbolsLanding = _anticipationSymbolsLanded;
    _startAnticipationDelayFromReel = -2;

    for (let reelID = 0; reelID < reelManager.reels.length; reelID++) {
      for (let i = 0; i < 5; i++) {
        const symbolId = spinTask.data.resultPanel.reelList[reelID].symbols[i].value;

        if (symbolId === anticipationConfig.requiredSymbol) {
          _anticipationSymbolsLanding++;
          const numRequiredSymbols = freespins.inFreespins
            ? anticipationConfig.numRequiredSymbolsFS
            : anticipationConfig.numRequiredSymbols;
          if (
            reelID < reelManager.reels.length - 1 && // symbol not on the last reel
            _anticipationSymbolsLanding >= numRequiredSymbols &&
            _startAnticipationDelayFromReel === -2
          ) {
            _startAnticipationDelayFromReel = reelID;
          }
        } else {
        }
      }
    }
  };

  gameController.reelsFromThisOneHaveAnythingToDrop = function (fromReelIndex) {
    let result = false;

    let amountMoving = 0;
    for (let i = fromReelIndex + 1; i < gameData.reels.length; i++) {
      const symbolDropDeltas = gameData.reels[i].symbolDropDeltas;
      for (let k = 0; k < symbolDropDeltas.length; k++) {
        if (symbolDropDeltas[k] > 0) {
          amountMoving++;
        }
      }
    }

    if (amountMoving > 0) {
      result = true;
    }

    return result;
  };

  gameController.calcAnticipationForDrops = function (reels) {
    const anticipationConfig = resourceManager.getConfiguration().anticipationConfig;

    _anticipationSymbolsLanding = _anticipationSymbolsLanded;
    if (_startAnticipationDelayFromReel !== -1) {
      _startAnticipationDelayFromReel = -2;
    } else {
      // -1 means we are already delaying from the 1st reel
    }

    // we are breaking up how the symbols drop when anticipation is required
    // drop old 1st, then start the anims, then drop new
    // the only issue with this is mid drop.
    // from 1st reel is easy, but mid drop i feel is next to impossible at the moment
    // with the way the reels are currently coded, and all the callbacks etc
    // so simply return for now
    return;

    // for (let reelID = 0; reelID < reels.length; reelID++) {
    //   for (let i = 0; i < 5; i++) {
    //     const symbolId = reels[reelID].symbolData[i].symbolId;
    //     if (
    //       symbolId === anticipationConfig.requiredSymbol &&
    //       reels[reelID].symbolSprites[i].droppingInFromOff === true
    //     ) {
    //       _anticipationSymbolsLanding++;
    //       const numRequiredSymbols = freespins.inFreespins
    //         ? anticipationConfig.numRequiredSymbolsFS
    //         : anticipationConfig.numRequiredSymbols;

    //       if (_anticipationSymbolsLanding >= numRequiredSymbols && _startAnticipationDelayFromReel === -2) {
    //         // before we enable, can we check to see if any more reels are going to drop any symbols?
    //         // if not, then there is no point setting this
    //         if (gameController.reelsFromThisOneHaveAnythingToDrop(reelID)) {
    //           _startAnticipationDelayFromReel = reelID;
    //         }
    //       }
    //     } else {
    //     }
    //   }
    // }
  };

  // when reel has landed all symbols - mark as no longer spinning
  gameController.onSpinCompleteBase = function (reelID) {
    _reelsSpinning[reelID] = false;
  };

  gameController.anyWildsInWins = function () {
    let wildSymbolFound = false;
    const payWaysWins = _payWinsEvent.data.payWaysLeft.payWaysWins;
    for (let i = 0; i < payWaysWins.length && !wildSymbolFound; i++) {
      const payWaysWin = payWaysWins[i];
      for (let k = 0; k < payWaysWin.winSymPositions.length && !wildSymbolFound; k++) {
        const winSymPosition = payWaysWin.winSymPositions[k];
        if (winSymPosition.sym === 9) {
          // this is a wild
          wildSymbolFound = true;
        }
      }
    }
    return wildSymbolFound;
  };

  gameController.stateMachine.addState('PAYWINS', function () {
    if (gameController.phase.once()) {
      // are there any magic beans which need to be animated 1st?
      _animWinsFinished = false;

      const isCapped = _payWinsEvent.data.isCapped;
      if (gameController.anyWildsInWins() === true) {
        _payWinsEvent.data.wasCapped = _payWinsEvent.data.isCapped;
        _payWinsEvent.data.isCapped = false;
        _payWinsEvent.data.justWilds = true;
        PayAnywhereWinAnimator.animate(
          _payWinsEvent.data,
          function () {
            _animWinsFinished = true;
          },
          function () {}
        );
      } else {
        // no anims to play
        _animWinsFinished = true;
      }
    }

    if (gameController.phase.hold()) {
      if (_animWinsFinished) {
        console.log('magic beans anim finished or there were non to animate');
        gameController.phase.step();
      }
    }

    if (gameController.phase.once()) {
      _animWinsFinished = false;

      if (freespins.inFreespins) {
        _bgTrail.playJackNormalWinAnim();
      }

      // pass in the max win - isCapped
      if (typeof _payWinsEvent.data.wasCapped === 'boolean') {
        _payWinsEvent.data.isCapped = _payWinsEvent.data.wasCapped;
      }
      _outcomesPanel.addAllWinsToPanel(_payWinsEvent.data.payWaysLeft.payWaysWins, _payWinsEvent.data.isCapped);

      _payWinsEvent.data.justWilds = false;
      PayAnywhereWinAnimator.animate(
        _payWinsEvent.data,
        function () {
          _animWinsFinished = true;
        },
        function () {}
      );

      if (gameData.winningsContainer.visible === false) {
        gameData.winningsContainer.visible = true;
        gameData.messageContainer.visible = false;
      }

      // ??? capped check here!!
      const sp = gdk.getServerParser();
      if (
        _payWinsEvent.data.isCapped &&
        gameData.winningsMeter.value + _payWinsEvent.data.totalLineWinnings >= sp.getMaxWin() // also check to see if this win takes us over
      ) {
        const sp = gdk.getServerParser();
        _winningsMeterCapped = true;
        gameData.winningsMeter.set(sp.getMaxWin());
      } else {
        gameData.winningsMeter.countUp(_payWinsEvent.data.totalLineWinnings, 200);
      }

      if (freespins.inFreespins) {
        const freeSpinsTotalWinPanel = resourceManager.get(
          'slotContainer:freeSpinsTotalWinPanelContainer:FreeSpinsTotalWinPanel'
        );
        if (freeSpinsTotalWinPanel.visible === false) {
          freeSpinsTotalWinPanel.show();
          hideGameLogo();
        }
        freeSpinsTotalWinPanel.countUp(_payWinsEvent.data.totalLineWinnings, 200, _winningsMeterCapped);
      }
    }

    if (gameController.phase.hold()) {
      if (_animWinsFinished) {
        console.log('winning anims finished');
        gameController.phase.step();
      }
    }

    if (gameController.phase.once()) {
      console.log('gameController::switching state to PRE_POP_SYMBOLS');
      gameController.stateMachine.switchState('PRE_POP_SYMBOLS');
    }
  });

  gameController.skipWins = function () {
    _skipWin = true;
  };

  /*gameController.stateMachine.addState('AWARD_MULTIPLIER', function () {
    if (gameController.phase.once()) {
      console.log('gameController::switchState to PRE_POP_SYMBOLS');
      gameController.stateMachine.switchState('PRE_POP_SYMBOLS');
    }
  });*/

  gameController.showOverlay = function () {
    if (darkOverlay === undefined) return;

    if (darkOverlayShowing) return;

    darkOverlayShowing = true;
    darkOverlay.visible = true;
    darkOverlay.alpha = 0;

    gsap.to(darkOverlay, {
      duration: 0.4,
      alpha: 0.3,
    });
  };

  gameController.winSkipped = function () {
    return _skipWin;
  };

  gameController.hideOverlay = function () {
    if (darkOverlay === undefined) return;

    if (!darkOverlayShowing) return;

    darkOverlayShowing = false;

    gsap.to(darkOverlay, {
      duration: 0.4,
      alpha: 0,
      onComplete: () => {
        darkOverlay.visible = false;
      },
    });
  };

  gameController.stateMachine.addState('PRE_POP_SYMBOLS', function () {
    if (gameController.phase.once()) {
      gameController.hideOverlay();
      console.log('gameController::switchState to WAITING_FOR_SERVER');
      gameController.stateMachine.switchState('WAITING_FOR_SERVER');
      _payWinsEvent.leave();
    }
  });

  gameController.stateMachine.addState('POP_SYMBOLS', function () {
    // this is where i think we should handle the pop animation
    // before dropping the symbols
    if (gameController.phase.enter()) {
    }

    if (gameController.phase.once()) {
      var slotMachine = GameSlotMachineFactory.getSlotMachine(0);
      // const symbolDisappearAnimContainer = resourceManager.get('slotContainer:reelContainer:foregroundReelSymbols');
      const symbolDisappearAnimContainer = resourceManager.get('slotContainer:foregroundReelSymbols');

      _reelToFrespinsBarFlying = 0;
      _popData = [];
      _allPopsComplete = false;
      _numPoppingSymbols = 0;

      for (var reel = 0; reel < reelManager.reels.length; ++reel) {
        var popData = [];
        var totalDropping = 0;

        for (var row = 0; row < 5; ++row) {
          popData.push(_dropEvent.data.tumbleData[reel][row] !== 0);

          if (popData[row]) {
            totalDropping++;
            _numPoppingSymbols++;

            if (!_modifierEventTriggered) {
              symbolDisappearAnimContainer.addChild(_symbolDisappearAnims[reel][row]);
              _symbolDisappearAnims[reel][row].gotoAndPlay(0);
              _symbolDisappearAnims[reel][row].onComplete = () => {
                _numPoppingSymbols--;
                if (_numPoppingSymbols <= 0) {
                  for (let k = 0; k < reelManager.reels.length; k++) {
                    for (let i = 0; i < _symbolDisappearAnims[k].length; i++) {
                      symbolDisappearAnimContainer.removeChild(_symbolDisappearAnims[k][i]);
                    }
                  }
                  _allPopsComplete = true;
                }
              };
            }

            // i think we need to add a listener to the animated sprites
            // and count down the amount of anims playing
            // and wait for them to finish before setting _allPopsComplete
            // _allPopsComplete = true;
          }
        }

        // Tell reels to pop (wait for drop)
        _popData.push(popData);

        // Use this to pop symbols off TODO SA 05/04 -1 means remove symbol array
        // this removes and drops
        const eggMultipliers = [];
        if (_dropEvent.data.eggMultipliers !== null) {
          // now we need to see if we have any info for this reel
          for (let i = 0; i < _dropEvent.data.eggMultipliers.length; i++) {
            if (_dropEvent.data.eggMultipliers[i].position.reel === reel) {
              eggMultipliers[_dropEvent.data.eggMultipliers[i].position.offset] =
                _dropEvent.data.eggMultipliers[i].multiplier;
            }
          }
        }
        slotMachine.reels[reel].popSymbols(popData, _dropEvent.data.window[reel], eggMultipliers);

        // i think this is where we should leave symbols where they are, and new ones need to be
        // put in the masked container
        // then moved to the non masked when stoped
        // dont think this should be done here!!!!
        // gameController.addOversizedSymbols();
      }

      gameController.playExplodeSound();

      if (!freespins.inFreespins || _bgTrail.maxMinMultiplierReached() === false) {
        _bgTrail.incrementTrail();
      }
    }

    if (gameController.phase.hold()) {
      if (_allPopsComplete && _bgTrail.incrementTrailFinished() === true) {
        gameController.phase.step();
      }
    }

    // do we need to show the max win pop up?
    // if (gameController.phase.once()) {
    //   if (_dropEvent.data.isCapped === true) {
    //     showMaxWinPopup(1000);
    //   }
    // }

    // if (gameController.phase.hold()) {
    //   if (_dropEvent.data.isCapped !== true || _showingMaxWinPopup !== true) {
    //     gameController.phase.step();
    //   }
    // }

    if (gameController.phase.once()) {
      if (!freespins.inFreespins && _bgTrail.isFull() === true) {
        musicManager.fadeLevels(
          musicManager.SINGLEWINLEVEL,
          musicManager.fadeLevelTimeIn,
          musicManager.fadeLevelTimeOut,
          1,
          0
        );
      }

      if (freespins.inFreespins && _bgTrail.isFull() === true && _bgTrail.maxMinMultiplierReached() === false) {
        // now before we drop any symbols, lets
        // now im not sure if when we are in free spins,
        // do we upgrade straight away if the trail is full
        // or once all the cascades are finished, like the base game
        console.log('gameController::switchState to UPGRADE_MIN_MULTIPLIER');
        gameController.stateMachine.switchState('UPGRADE_MIN_MULTIPLIER');
      } else {
        console.log('gameController::switchState to DROP_SYMBOLS');
        gameController.stateMachine.switchState('DROP_SYMBOLS');
      }
    }
  });

  gameController.playExplodeSound = function () {
    let explodeIndex = _numberOfPops - 1;
    if (_numberOfPops > _explodeSounds.length - 1) {
      _numberOfPops = _explodeSounds.length - 1;
    }
    soundManager.play(_explodeSounds[explodeIndex]);
  };

  gameController.stateMachine.addState('UPGRADE_MIN_MULTIPLIER', function () {
    if (gameController.phase.once()) {
      _bgTrail.upgradeMinMultiplier();
    }

    if (gameController.phase.hold()) {
      if (_bgTrail.upgradingMinMultiplierFinished() === true) {
        gameController.phase.step();
      }
    }

    if (gameController.phase.once()) {
      if (_bgTrail.maxMinMultiplierReached() !== true) {
        _bgTrail.reset();
      } else {
        // _bgTrail.stopBurst();
      }
      console.log('gameController::switchState to DROP_SYMBOLS');
      gameController.stateMachine.switchState('DROP_SYMBOLS');
    }
  });

  // this drops new and old symbols after a previous win!!
  gameController.stateMachine.addState('DROP_SYMBOLS', function () {
    if (gameController.phase.enter()) {
    }

    if (gameController.phase.once()) {
      // look to see if we need landing anims on new symbols?
      _symbolCallbackFired = [];
      gameController.calcLandingAnimsForDrops(gameData.reels);
      const anticipationConfig = resourceManager.getConfiguration().anticipationConfig;
      const numRequiredSymbols = freespins.inFreespins
        ? anticipationConfig.numRequiredSymbolsFS
        : anticipationConfig.numRequiredSymbols;

      if (_winningsMeterCapped !== true) {
        if (_anticipationSymbolsLanded >= numRequiredSymbols) {
          _startAnticipationDelayFromReel = -1;
          // this needs to be called once all the old symbols have landed
          // gameController.startExistingAnticipationSymbolsLooping();
        } else {
          gameController.calcAnticipationForDrops(gameData.reels);
        }
      } else {
        _startAnticipationDelayFromReel = -2;
      }
    }

    if (gameController.phase.timed(500)) {
      // start anticipation right from the start
      const anticipationConfig = resourceManager.getConfiguration().anticipationConfig;
      const numRequiredSymbols = freespins.inFreespins
        ? anticipationConfig.numRequiredSymbolsFS
        : anticipationConfig.numRequiredSymbols;

      if (_anticipationSymbolsLanded < numRequiredSymbols) {
        gameController.phase.step();
      }
    }

    if (gameController.phase.once()) {
      // Drop symbols
      _dropsRemaining = 6; // setup just before the drops are made
      _tempPopData = _popData;
      let delayTime = 125;
      let delayIndex = 0;

      _modifierEventTriggered = false;
      _popData = [];
      _specialEvent = false;

      // here we need to see what symbols are coming in
      // regenerate colossal data but only with symbols that are new
      // dont create colossals if we have anticipation
      const convertToColossals = gameController.startAnticipationDelayFromReel === -2 ? true : false;
      _colossalData = slotMachine.generateColossalDataAfterPop(gameData.reels, convertToColossals);

      // before we drop, show the new symbols
      for (let reel = 0; reel < reelManager.reels.length; ++reel) {
        if (_tempPopData[reel] !== undefined) {
          for (let row = 0; row < 5; ++row) {
            if (_tempPopData[reel][row]) {
              gameData.reels[reel].showSymbol(row, true);
            }
          }
        }
      }

      // before we drop, we need to make sure we are showing the colossal
      for (let i = 0; i < _colossalData.length; i++) {
        for (let j = 0; j < _colossalData[i].length; j++) {
          if (_colossalData[i][j]) {
            // have colossal information
            const symbol = _colossalData[i][j].symbolId;
            gameData.reels[i].setSymbol(j, symbol, null, _colossalData);
          }
        }
      }

      // what happens if we have anticipation
      if (gameController.startAnticipationDelayFromReel === -2) {
        // no anticipation, just drop as before
        const delays = slotMachine.createDropDelays(_colossalData, _tempPopData);
        console.log('drop delays are', delays);
        for (let i = 0; i < _tempPopData.length; i++) {
          gameData.reels[i].dropSymbols(delays[i], _tempPopData[i], onDropComplete);
        }
      } else {
        // what if gameController.startAnticipationDelayFromReel != -1
        // it wont now, we are disabling anticipation starting mid drop
        const delays = slotMachine.createDropDelaysForOldSymbols(_colossalData, _tempPopData, 0);
        console.log('drop delays for old are', delays);
        soundManager.play('dropSymbolsNormal');
        for (let i = 0; i < _tempPopData.length; i++) {
          gameData.reels[i].dropOldSymbols(delays[i], _tempPopData[i], onDropOldSymbolsComplete);
        }
      }
    }

    if (gameController.phase.exit()) {
    }
  });

  gameController.stateMachine.addState('POP_AND_DROP_COMPLETE', function () {
    if (gameController.phase.once()) {
      // isCapped is a bit heavy handed i think, so lets also compare with the winningsMeter
      // especially if we have a multiplier to award from the trail
      if (_popAndDropCompleteEvent.data.isCapped === true && _winningsMeterCapped === true && _maxWinShown === false) {
        showMaxWinPopup();
      }
    }

    if (gameController.phase.hold()) {
      if (_showingMaxWinPopup !== true) {
        gameController.phase.step();
      }
    }

    if (gameController.phase.once()) {
      // is the trail full?
      // is the trail awarding a multiplier?
      // do we know what the multiplier is?

      let multiplierFromEggBeingAwarded = _popAndDropCompleteEvent.data.cascadeClimber?.outcome === 2; // outcome 2 = multiplier is being awarded

      if (_bgTrail.isFull() === true && _bgTrail.hasPrizeBeenAwarded() === false && _maxWinShown !== true) {
        if (multiplierFromEggBeingAwarded === true) {
          // we need to show the pre multiplied win in the middle
          // we need to reveal the the multiplier in the egg
          // then we need to move the multiplier over the value
          // show new value
          // then decide if we want to show big win
          // regardless of big win needing to be shown we need to show the final value
          // before we apply the multiplier
          // then move onto SHOW_BIG_WIN
          console.log('gameController::switchState to REVEAL_EGG_MULTIPLIER');
          gameController.stateMachine.switchState('REVEAL_EGG_MULTIPLIER');
        } else {
          // must be awarding free spins, so we need to animate bonus symbol
          // going to the right place
          console.log('gameController::switchState to REVEAL_EGG_BONUS_SYMBOL');
          gameController.stateMachine.switchState('REVEAL_EGG_BONUS_SYMBOL');
        }
      } else {
        _bgTrail.stopPulsing();
        if (_maxWinShown === true) {
          _bgTrail.reset();
        }

        // we didnt fill the trail
        const isBigWin = _bigWin.willTriggerBigWin(
          _popAndDropCompleteEvent.data.winnings,
          gameController.globalHelperGetBaseStake()
        );
        // dont show big win if bonus buy used
        if (isBigWin === true && !gameController.inBuyABonus && !gameController.inBuyASuperBonus) {
          console.log('gameController::switchState to SHOW_BIGWIN');
          gameController.stateMachine.switchState('SHOW_BIGWIN');
        } else {
          if (gameController.canCelebrate) {
            console.log('gameController::switchState to SHOW_FINAL_WINNINGS');
            gameController.stateMachine.switchState('SHOW_FINAL_WINNINGS');
          } else {
            // the value we have won is less than stake
            // so we shouldnt pop anything up at this point

            console.log('gameController::switchState to WAITING_FOR_SERVER from onPopAndDropComplete');
            gameController.stateMachine.switchState('WAITING_FOR_SERVER');

            if (!freespins.inFreespins) {
              gameData.inputOverlord.setState('enabled');
            }

            _popAndDropCompleteEvent.leave();
          }
        }
      }
    }
  });

  upgradeFSEggMultipliers = async function () {
    _upgradingFSEggMultipliers = true;

    const minMultiplier = _bgTrail.getMinMultiplier();

    // need to go through each egg and check their multiplier
    soundManager.play('bgEggGlow');
    const eggID = resourceManager.getConfiguration().symbols['GoldenEggSmall'].ID;
    const largeEggID = resourceManager.getConfiguration().symbols['GoldenEggLarge'].ID;
    for (let i = 0; i < reelManager.reels.length; i++) {
      const reel = reelManager.reels[i];
      for (let j = 0; j < reel.symbolData.length; j++) {
        const symbolData = reel.symbolData[j];
        if (symbolData.symbolId === eggID || symbolData.symbolId === largeEggID) {
          if (symbolData.eggMultiplier < minMultiplier) {
            await _bgTrail.highlightMinMultiplier();
            await reel.upgradeFSEggMultiplier(j, minMultiplier);
          }
        }
      }
    }

    _upgradingFSEggMultipliers = false;
  };

  gameController.stateMachine.addState('UPGRADE_FS_EGG_MULTIPLIERS', function () {
    if (gameController.phase.once()) {
      upgradeFSEggMultipliers();
    }

    if (gameController.phase.hold()) {
      if (_upgradingFSEggMultipliers !== true) {
        gameController.phase.step();
      }
    }

    if (gameController.phase.once()) {
      console.log('gameController::switchState to APPLY_FS_EGG_MULTIPLIERS');
      gameController.stateMachine.switchState('APPLY_FS_EGG_MULTIPLIERS');
    }
  });

  applyFSEggMultipliers = async function () {
    _applyingFSEggMultipliers = true;

    const freeSpinsTotalWinPanel = resourceManager.get(
      'slotContainer:freeSpinsTotalWinPanelContainer:FreeSpinsTotalWinPanel'
    );

    // need to go through each egg and check their multiplier
    const eggID = resourceManager.getConfiguration().symbols['GoldenEggSmall'].ID;
    const largeEggID = resourceManager.getConfiguration().symbols['GoldenEggLarge'].ID;
    for (let i = 0; i < reelManager.reels.length; i++) {
      const reel = reelManager.reels[i];
      for (let j = 0; j < reel.symbolData.length; j++) {
        const symbolData = reel.symbolData[j];
        if (symbolData.symbolId === eggID || symbolData.symbolId === largeEggID) {
          await reel.awardFSEggMultiplier(j);
        }
      }
    }

    // all eggs have moved to the panel
    await timerManager.delayAsync(750);

    // now lets have an explosion and set the value under the explosion

    // work out the correct value
    // if we have hit max cap
    // and show that
    // along with the max win pop up
    // then continue

    // let valueBefore = _popAndDropCompleteEvent.data.finalBaseWinningsPreMult; // freeSpinsTotalWinPanel.getValue();
    // let finalMultiplier = _popAndDropCompleteEvent.data.finalMultiplier;
    // let finalValue = _popAndDropCompleteEvent.data.finalBaseWinnings; //valueBefore * finalMultiplier;
    // let difference = finalValue - valueBefore;

    let valueBefore = freeSpinsTotalWinPanel.getValue();
    let finalMultiplier = _popAndDropCompleteEvent.data.finalMultiplier;
    let finalValue = valueBefore * finalMultiplier;
    let difference = finalValue - valueBefore;

    let jackAnimPromise = null;
    if (finalMultiplier >= 20) {
      jackAnimPromise = _bgTrail.playJackBigWinAnim();
    }

    if (gameData.winningsContainer.visible === false) {
      gameData.winningsContainer.visible = true;
      gameData.messageContainer.visible = false;
    }

    if (_popAndDropCompleteEvent.data.isCapped) {
      // debugger;
      const sp = gdk.getServerParser();
      finalValue = _popAndDropCompleteEvent.data.winnings; //maxWin - fromMeter;
      gameData.winningsMeter.set(sp.getMaxWin());
      _winningsMeterCapped = true;
    } else {
      // use defaults
    }

    await freeSpinsTotalWinPanel.setFinalValue(
      finalValue,
      () => {
        if (_popAndDropCompleteEvent.data.isCapped) {
          // gameData.winningsMeter.set(sp.getMaxWin());
        } else {
          gameData.winningsMeter.countUp(difference, 200);
        }
      },
      _popAndDropCompleteEvent.data.isCapped
    );

    if (_popAndDropCompleteEvent.data.isCapped && _maxWinShown === false) {
      await showMaxWinPopup();
    } else {
      await timerManager.delayAsync(1000);
    }

    await jackAnimPromise;

    _applyingFSEggMultipliers = false;
  };

  showMaxWinPopup = async function (extraDelay) {
    _maxWinShown = true;
    _showingMaxWinPopup = true;
    const maxWinPopup = resourceManager.get('maxWinPopup');
    const pressStartBox = resourceManager.get('maxWinPopup:pressStartColourBox');

    pressStartBox.interactive = false;

    if (extraDelay > 0) {
      await timerManager.delayAsync(extraDelay);
    }

    maxWinPopup.visible = true;
    await game.tweenFromToAsync(maxWinPopup, { alpha: 0 }, { alpha: 1, duration: 0.5 });

    let resolver = null;
    const promise = new Promise((resolve) => {
      resolver = resolve;
    });

    pressStartBox.mousedown = pressStartBox.touchstart = () => {
      pressStartBox.interactive = false;
      resolver();
    };

    pressStartBox.interactive = true;

    await promise;

    pressStartBox.mousedown = pressStartBox.touchstart = undefined;

    await game.tweenFromToAsync(maxWinPopup, { alpha: 1 }, { alpha: 0, duration: 0.25 });

    maxWinPopup.visible = false;
    _showingMaxWinPopup = false;
  };

  gameController.stateMachine.addState('APPLY_FS_EGG_MULTIPLIERS', function () {
    if (gameController.phase.once()) {
      applyFSEggMultipliers();
    }

    if (gameController.phase.hold()) {
      if (_applyingFSEggMultipliers !== true) {
        gameController.phase.step();
      }
    }

    if (gameController.phase.once()) {
      console.log('gameController::switchState to POP_AND_DROP_COMPLETE_FS');
      gameController.stateMachine.switchState('POP_AND_DROP_COMPLETE_FS');
    }
  });

  gameController.stateMachine.addState('JACK_NEGATIVE_ANIM', function () {
    if (gameController.phase.once()) {
      _bgTrail.playJackSwayWinAnim();
    }

    if (gameController.phase.hold()) {
      if (_bgTrail.hasJackSwayAnimFinished() === true) {
        gameController.phase.step();
      }
    }

    if (gameController.phase.once()) {
      console.log('gameController::switchState to POP_AND_DROP_COMPLETE_FS');
      gameController.stateMachine.switchState('POP_AND_DROP_COMPLETE_FS');
    }
  });

  gameController.stateMachine.addState('JACK_NEGATIVE_ANIM_NO_WIN', function () {
    if (gameController.phase.once()) {
      _bgTrail.playJackSwayWinAnim();
    }

    if (gameController.phase.hold()) {
      if (_bgTrail.hasJackSwayAnimFinished() === true) {
        gameController.phase.step();
      }
    }

    if (gameController.phase.once()) {
      _popAndDropCompleteEvent.leave();
    }
  });

  gameController.stateMachine.addState('POP_AND_DROP_COMPLETE_FS', function () {
    if (gameController.phase.once()) {
      // setting this just to be safe
      if (!_winningsMeterCapped) {
        if (gameData.winningsContainer.visible === false) {
          gameData.winningsContainer.visible = true;
          gameData.messageContainer.visible = false;
        }
        gameData.winningsMeter.set(_popAndDropCompleteEvent.data.wonSoFar);
      }
    }

    if (gameController.phase.once()) {
      // before we move on, do we have a big win presentation to do
      let totalWinnings = _popAndDropCompleteEvent.data.winnings;
      const isBigWin = _bigWin.willTriggerBigWin(totalWinnings, gameController.globalHelperGetBaseStake());

      let minWinRequired = 0;
      if (gameController.inBuyABonus || gameController.inBuyASuperBonus) {
        minWinRequired = gameController.globalHelperGetStake();
      }

      if (isBigWin === true && totalWinnings >= minWinRequired) {
        console.log('gameController::switchState to SHOW_BIGWIN_FS');
        gameController.stateMachine.switchState('SHOW_BIGWIN_FS');
      } else {
        console.log('gameController::switchState to WAITING_FOR_SERVER from onPopAndDropComplete fs');
        gameController.stateMachine.switchState('WAITING_FOR_SERVER');
        // what if we have retriggers? do we care?
        gameController.popAndDropCompleteFSEvent(500);
      }
    }
  });

  gameController.popAndDropCompleteFSEvent = async function (delay) {
    if (delay > 0) {
      await timerManager.delayAsync(delay);
    }
    _popAndDropCompleteEvent.leave();
  };

  gameController.stateMachine.addState('AWARD_SCATTER_WINS', function () {
    if (gameController.phase.once()) {
      // start the presentation of scatter wins, hand this over to payanywhere etc etc
      // e.g. animate scatter symbols
      // add entry to the win panel
      // update total win on the balance bar
      // update can celebrate
      gameController.canCelebrate = _totalWinnings > resourceManager.getController('stakeController').CurrentStake;
      let winnings = _popAndDropCompleteEvent.data.finalBaseWinningsInitialScatterWinPreMult;

      PayAnywhereWinAnimator.presentScatterWin();
      _outcomesPanel.addWinToPanel({
        symbolIndex: resourceManager.getConfiguration().symbols['Bonus'].ID,
        totalWin: winnings,
        count: gameController.numberOfBonusSymbolsOnReels(),
      });

      if (gameData.winningsContainer.visible === false) {
        gameData.winningsContainer.visible = true;
        gameData.messageContainer.visible = false;
      }

      const sp = gdk.getServerParser();
      if (
        _popAndDropCompleteEvent.data.isCapped &&
        gameData.winningsMeter.value + winnings >= sp.getMaxWin() // also check to see if this win takes us over
      ) {
        const sp = gdk.getServerParser();
        _winningsMeterCapped = true;
        gameData.winningsMeter.set(sp.getMaxWin());
      } else {
        gameData.winningsMeter.countUp(winnings, 200);
      }

      if (freespins.inFreespins) {
        const freeSpinsTotalWinPanel = resourceManager.get(
          'slotContainer:freeSpinsTotalWinPanelContainer:FreeSpinsTotalWinPanel'
        );
        if (freeSpinsTotalWinPanel.visible === false) {
          freeSpinsTotalWinPanel.show();
          hideGameLogo();
        }
        freeSpinsTotalWinPanel.countUp(winnings, 200, _popAndDropCompleteEvent.data.isCapped);
      }
    }

    if (gameController.phase.hold()) {
      // stick around here until the scatter presentation has done
      // then step out when finished
      if (PayAnywhereWinAnimator.hasPresentScatterWinsFinished() === true) {
        gameController.phase.step();
      }
    }

    // do what needs to be done
    if (gameController.phase.once()) {
      if (!freespins.inFreespins) {
        if (_scatterWinPostponed === true) {
          console.log('gameController::switchState to SHOW_FINAL_WINNINGS');
          gameController.stateMachine.switchState('SHOW_FINAL_WINNINGS');
        } else {
          console.log('gameController::switchState to POP_AND_DROP_COMPLETE');
          gameController.stateMachine.switchState('POP_AND_DROP_COMPLETE');
        }
      } else {
        if (gameController.numberOfEggSymbolsOnReels() > 0) {
          // now do we have any eggs that need upgrading?
          if (gameController.anyEggsThatNeedUpgrading() === true) {
            console.log('gameController::switchState to UPGRADE_FS_EGG_MULTIPLIERS');
            gameController.stateMachine.switchState('UPGRADE_FS_EGG_MULTIPLIERS');
          } else {
            console.log('gameController::switchState to APPLY_FS_EGG_MULTIPLIERS');
            gameController.stateMachine.switchState('APPLY_FS_EGG_MULTIPLIERS');
          }
        } else {
          console.log('gameController:: no eggs on reels');
          console.log('gameController::switchState to POP_AND_DROP_COMPLETE_FS');
          gameController.stateMachine.switchState('POP_AND_DROP_COMPLETE_FS');
        }
      }
    }
  });

  gameController.stateMachine.addState('SHOW_FINAL_WINNINGS', function () {
    if (gameController.phase.once()) {
      if (!freespins.inFreespins) {
        // why do this?
        gameData.inputOverlord.setState('payToWinnings');
      } else {
        // in free spins - tbc
      }
    }

    if (gameController.phase.timed(200)) {
    }

    if (gameController.phase.once()) {
      for (var i = 0; i < reelManager.reels.length; i++) {
        reelManager.reels[i].dimAllSymbols(true, 0x666666);
      }

      if (_maxWinShown === true) {
        const sp = gdk.getServerParser();
        _totalWinnings = sp.getMaxWin();
      }
      soundManager.play('finalValueIn');
      gameData.winningsText.show(true, _totalWinnings);
      gameData.winningsText.bounceText(500);
    }

    if (gameController.phase.hold()) {
      if (gameData.winningsText.isTextBouncing() !== true) {
        gameController.phase.step();
      }
    }

    if (gameController.phase.timed(1500)) {
    }

    // now we need to decide if the winnings need to be removed or
    // award the multiplier
    if (gameController.phase.once()) {
      let multiplierFromEggBeingAwarded = _popAndDropCompleteEvent.data.cascadeClimber?.outcome === 2; // outcome 2 = multiplier is being awarded

      if (
        _bgTrail.isFull() === true && // not sure we need the isFull check
        multiplierFromEggBeingAwarded === true
      ) {
        console.log('gameController::switchState to AWARD_EGG_MULTIPLIER');
        gameController.stateMachine.switchState('AWARD_EGG_MULTIPLIER');
      } else {
        console.log('gameController::switchState to REMOVE_FINAL_WINNINGS');
        gameController.stateMachine.switchState('REMOVE_FINAL_WINNINGS');
      }
    }
  });

  gameController.stateMachine.addState('REMOVE_FINAL_WINNINGS', function () {
    if (gameController.phase.once()) {
    }

    if (gameController.phase.timed(250)) {
      gameData.winningsText.alpha = 1 - gameController.phase.Progress;
    }

    if (gameController.phase.once()) {
      soundManager.play('finalValueOut');
      gameData.winningsText.show(false);
      gameData.winningsText.alpha = 1;
      for (var i = 0; i < reelManager.reels.length; i++) {
        reelManager.reels[i].dimAllSymbols(false);
      }
    }

    if (gameController.phase.once()) {
      if (freespins.inFreespins) {
        // musicManager.freeSpinsNextLevel();
      }

      soundManager.stop('winCountUp');

      gameData.winningsMeterTitle.visible = true;
    }

    if (gameController.phase.once()) {
      // now, have we awarded a multiplier?
      // if so, then we would of done all that before showing big win
      // so we need to know if we are to show big win instead of WAITING_FOR_SERVER
      const multiplierFromEggBeingAwarded = _popAndDropCompleteEvent.data.cascadeClimber?.outcome === 2; // outcome 2 = multiplier is being awarded
      const isBigWin = _bigWin.willTriggerBigWin(
        _popAndDropCompleteEvent.data.winnings,
        gameController.globalHelperGetBaseStake()
      );

      if (_bgTrail.isFull() === true && multiplierFromEggBeingAwarded === true && isBigWin === true) {
        console.log('gameController::switchState to SHOW_BIGWIN');
        gameController.stateMachine.switchState('SHOW_BIGWIN');
      } else {
        console.log('gameController::switchState to WAITING_FOR_SERVER');
        gameController.stateMachine.switchState('WAITING_FOR_SERVER');

        if (!freespins.inFreespins) {
          gameData.inputOverlord.setState('enabled');
        }

        _popAndDropCompleteEvent.leave();
      }
    }
  });

  gameController.stateMachine.addState('REVEAL_EGG_MULTIPLIER', function () {
    if (gameController.phase.once()) {
      _bgTrail.revealMultiplier(_popAndDropCompleteEvent.data.cascadeClimber.multiplier);
    }

    if (gameController.phase.hold()) {
      if (_bgTrail.multiplierRevealed() === true) {
        gameController.phase.step();
      }
    }

    if (gameController.phase.once()) {
      // now that we have revealed the multiplier, we now need to award a scatter if its present
      let scatterWin = _popAndDropCompleteEvent.data.finalBaseWinningsInitialScatterWinPreMult > 0;
      if (scatterWin && _scatterWinPostponed === true) {
        console.log('gameController::switchState to AWARD_SCATTER_WINS');
        gameController.stateMachine.switchState('AWARD_SCATTER_WINS');
        // make sure _totalWinnings contains the winnings with the scatter win also
        // waiting on value from server, as that should be capped im hoping
        _totalWinnings += _popAndDropCompleteEvent.data.finalBaseWinningsInitialScatterWinPreMult;
      } else {
        console.log('gameController::switchState to SHOW_FINAL_WINNINGS');
        gameController.stateMachine.switchState('SHOW_FINAL_WINNINGS');
      }
    }
  });

  gameController.stateMachine.addState('AWARD_EGG_MULTIPLIER', function () {
    if (gameController.phase.once()) {
      _bgTrail.awardEggMultiplier();
    }

    if (gameController.phase.hold()) {
      // wait here until the muliplier has moved over to where it needs to go
      if (_bgTrail.eggMultiplierAwarded() === true) {
        gameController.phase.step();
      }
    }

    if (gameData.winningsContainer.visible === false) {
      gameData.winningsContainer.visible = true;
      gameData.messageContainer.visible = false;
    }

    if (gameController.phase.once()) {
      _totalWinnings = _popAndDropCompleteEvent.data.winnings;
      gameData.winningsMeter.set(_totalWinnings);
      gameData.winningsText.setText(Math.floor(_totalWinnings));

      gameData.winningsText.playSparkleAnim();
    }

    if (gameController.phase.hold()) {
      if (gameData.winningsText.sparkleAnimPlaying() !== true) {
        gameController.phase.step();
      }
    }

    // do we need to show the max win pop up?
    if (gameController.phase.once()) {
      if (_popAndDropCompleteEvent.data.isCapped === true && _maxWinShown === false) {
        showMaxWinPopup();
      }
    }

    if (gameController.phase.hold()) {
      if (_popAndDropCompleteEvent.data.isCapped !== true || _showingMaxWinPopup !== true) {
        gameController.phase.step();
      }
    }

    if (gameController.phase.timed(1500)) {
      // just wait for 1500ms before removing the final winnings
    }

    if (gameController.phase.once()) {
      console.log('gameController::switchState to REMOVE_FINAL_WINNINGS');
      gameController.stateMachine.switchState('REMOVE_FINAL_WINNINGS');
    }
  });

  gameController.stateMachine.addState('REVEAL_EGG_BONUS_SYMBOL', function () {
    if (gameController.phase.once()) {
      _bgTrail.revealFS(_popAndDropCompleteEvent.data.cascadeClimber);
    }

    if (gameController.phase.hold()) {
      if (_bgTrail.fsRevealed() === true) {
        gameController.phase.step();
      }
    }

    if (gameController.phase.once()) {
      console.log('gameController::switchState to AWARD_EGG_BONUS_SYMBOL');
      gameController.stateMachine.switchState('AWARD_EGG_BONUS_SYMBOL');
    }
  });

  gameController.stateMachine.addState('AWARD_EGG_BONUS_SYMBOL', function () {
    if (gameController.phase.once()) {
      _bgTrail.awardEggFS(_popAndDropCompleteEvent.data.cascadeClimber);
    }

    if (gameController.phase.hold()) {
      if (_bgTrail.eggFSAwarded() === true) {
        gameController.phase.step();
      }
    }

    if (gameController.phase.once()) {
      // now we will have scatter wins to award
      console.log('gameController::switchState to AWARD_SCATTER_WINS');
      gameController.stateMachine.switchState('AWARD_SCATTER_WINS');
      _totalWinnings += _popAndDropCompleteEvent.data.finalBaseWinningsInitialScatterWinPreMult;
      // after scatter wins, the normal flow will be picked up as before
    }
  });

  gameController.stateMachine.addState('SHOW_BIGWIN', function () {
    // if (gameController.phase.timed(musicManager.fadeLevelTimeOut / 4)) {
    //   // small delay
    // }

    if (gameController.phase.once()) {
      _bigWin.start(_popAndDropCompleteEvent.data.winnings, false, null, null, null, 'basegame');
    }

    if (gameController.phase.hold()) {
      if (!_bigWin.isBigWinActive()) {
        gameController.phase.step();
      }
    }

    if (gameController.phase.once()) {
      console.log('gameController::switchState to WAITING_FOR_SERVER');
      gameController.stateMachine.switchState('WAITING_FOR_SERVER');

      gameData.inputOverlord.setState('enabled');

      _popAndDropCompleteEvent.leave();
    }
  });

  gameController.stateMachine.addState('SHOW_BIGWIN_FS', function () {
    if (gameController.phase.once()) {
      _bigWin.start(
        _popAndDropCompleteEvent.data.winnings,
        false,
        () => {
          _bgTrail.playJackBigWinAnim();
        },
        () => {
          _bgTrail.playJackNormalWinAnim();
        },
        null,
        'freespinsInter'
      );
    }

    if (gameController.phase.hold()) {
      if (!_bigWin.isBigWinActive()) {
        gameController.phase.step();
      }
    }

    if (gameController.phase.once()) {
      console.log('gameController::switchState to WAITING_FOR_SERVER');
      gameController.stateMachine.switchState('WAITING_FOR_SERVER');
      _popAndDropCompleteEvent.leave();
    }
  });

  gameController.stateMachine.addState('END_GAME', function () {
    if (gameController.phase.once()) {
      gameController.hideOverlay();
      logoIdleTimeline.play();

      const sp = gdk.getServerParser();
      const inReplayOrRewatch = sp._inReplayMode || sp._inRewatchMode;
      if (!inReplayOrRewatch) {
        updateStake();
      }

      inRecovery = false;

      // End of game cycle

      gdk.endGame(function () {
        _dropEvent = [];
        _payWinsEvent = [];
        console.log('gameController::switchState to WAIT_FOR_START');
        gameController.stateMachine.switchState('WAIT_FOR_START');
        gameData.spinToWinText.visible = true;
        gameData.goodLuckText.visible = false;
      });
    }
  });

  gameController.initialise = function () {
    _bigWin = resourceManager.get('bigWin:BigWin');
    _bigWin.init();
    freespins.initialise();
    _bgTrail = resourceManager.get('bgTrail:BGTrailContainer');
    _outcomesPanel = resourceManager.get('outcomesPanel:OutcomesPanel');
    _freeSpinsMeter = resourceManager.get('freeSpinsMeterContainer:freeSpinsMeter');
    _freeSpinsMeter.initialise();

    //resourceManager.getContainer('soundTrack').visible = true;

    titleAnim = resourceManager.get('slotContainer:logoContainer:logo');
    titleAnim.visible = true;

    logoIdleTimeline = gsap.timeline({ repeat: -1 }).call(
      () => {
        titleAnim.gotoAndPlay(0);
      },
      undefined,
      '<+=4'
    );
    logoIdleTimeline.play();

    const slamStopButton = resourceManager.get('buttonContainer:buttonBar:slamStopButton');
    slamStopButton.canEnableBase = slamStopButton.canEnable;
    slamStopButton.canEnable = function () {
      return this.canEnableBase() && gameController._receivedResponse;
    };

    const volumeButton = resourceManager.get('buttonContainer:buttonBar:mute');
    volumeButton.canShowBase = volumeButton.canShow;
    volumeButton.canShow = function () {
      return this.canShowBase() && settingsMenu.buttons.btnSound.visible;
    };

    resourceManager.get('buttonContainer:buttonBar:autoplayButton:glow').visible = false;

    resourceManager.get('slotContainer:reelsBorderFreeSpins').visible = false;

    darkOverlay = resourceManager.get('darkOverlay');
    darkOverlay.beginFill(0x000000);
    darkOverlay.lineStyle(0, 0x000000);
    darkOverlay.drawRect(0, 0, 1900, 1900);
    darkOverlay.visible = false;
    darkOverlayShowing = false;

    gameController.setupSymbolDisappearAnims();

    musicManager.onGameLoaded();

    gameController.parentAllOversizedSymbols();
  };

  gameController.getIsRecovery = function () {
    return inRecovery;
  };

  gameController.getIsIdle = function () {
    return _isGameIdle;
  };

  gameController.numberOfBonusSymbolsOnReels = function () {
    let count = 0;
    const bonusID = resourceManager.getConfiguration().symbols['Bonus'].ID;
    for (let i = 0; i < reelManager.reels.length; i++) {
      const reel = reelManager.reels[i];
      for (let j = 0; j < reel.symbolData.length; j++) {
        if (reel.symbolData[j].symbolId === bonusID) {
          count++;
        }
      }
    }
    return count;
  };

  gameController.numberOfEggSymbolsOnReels = function () {
    let count = 0;
    const eggID = resourceManager.getConfiguration().symbols['GoldenEggSmall'].ID;
    const largeEggID = resourceManager.getConfiguration().symbols['GoldenEggLarge'].ID;
    for (let i = 0; i < reelManager.reels.length; i++) {
      const reel = reelManager.reels[i];
      for (let j = 0; j < reel.symbolData.length; j++) {
        const symbolData = reel.symbolData[j];
        if (symbolData.symbolId === eggID || symbolData.symbolId === largeEggID) {
          count++;
        }
      }
    }
    return count;
  };

  gameController.anyEggsThatNeedUpgrading = function () {
    let result = false;

    // whats the min egg multiplier
    // where is best to get that?
    const minMultiplier = _bgTrail.getMinMultiplier();

    // need to go through each egg and check their multiplier
    const eggID = resourceManager.getConfiguration().symbols['GoldenEggSmall'].ID;
    const largeEggID = resourceManager.getConfiguration().symbols['GoldenEggLarge'].ID;
    for (let i = 0; i < reelManager.reels.length && !result; i++) {
      const reel = reelManager.reels[i];
      for (let j = 0; j < reel.symbolData.length && !result; j++) {
        const symbolData = reel.symbolData[j];
        if (symbolData.symbolId === eggID || symbolData.symbolId === largeEggID) {
          if (symbolData.eggMultiplier < minMultiplier) {
            result = true;
          }
        }
      }
    }

    return result;
  };

  gameController.onGameSkipped = function (stakeInfo) {
    // we make the meter show the correct stake on a restore, but nothing seems to set the stake controller up correctly if you press skip
    // so we have a new message and we do that here
    // ideally this should be in the libs somewhere!!
    const stakeController = resourceManager.getController('stakeController');

    // now we can have bonus buys on different stakes compared to normal
    // os 1st lets make sure the stake is valid for BASIC
    const stakeIndex = stakeController.Stakes.indexOf(stakeInfo.baseStake);
    if (stakeIndex === -1) {
      // the bonus buy stake isnt in the BASIC stake
      // so we need to use the default
      // this is assuming default stake has been set correctly :( as everything appears to be in closures!!
      stakeInfo.baseStake = stakeController.BaseStake;
    }

    stakeController.requestChangeStake(stakeInfo.baseStake);

    // as we skipped we should also hide the new messages
    // so the total win is shown
    gameData.winningsContainer.visible = true;
    gameData.messageContainer.visible = false;
  };

  ///////////////////
  // subscriptions //
  ///////////////////

  messageBus.subscribe('common:GameSkipped', gameController.onGameSkipped);
  messageBus.subscribe('common:GameCompleteEvent', preGameComplete);
  messageBus.subscribe('spinner:GambleResultEventDead', gambleResultEventDead);
  messageBus.subscribe('autoplay:started', autoplayStarted);
  messageBus.subscribe('autoplay:ended', autoplayEnded);
  messageBus.subscribe('spinner:SpinEvent', gameController.onSpinEvent); // inside spinFunctions.js
  messageBus.subscribe('spinner:WinningLinesEvent', doPayWins);
  messageBus.subscribe('game:DropEvent', onDropEvent);
  messageBus.subscribe('game:ModifierEvent', onModifierEvent);
  messageBus.subscribe('game:PopAndDropComplete', onPopAndDropComplete);
  messageBus.subscribe('common:RecoverGame', recoverGame);
  messageBus.subscribe('common:JackpotGame', jackpotGame);
  messageBus.subscribe('platform:startNextGame', startGame);
  messageBus.subscribe('common:AbortGame', onAbortGame);
  messageBus.subscribe('game:ExtraSpinsRemaining', onExtraSpinsRemaining);
  messageBus.subscribe('game:FreeSpinsAwardEvent', onFeatureAnnounced);
  messageBus.subscribe('game:FreeSpinsEndEvent', onFeatureEnded);

  Reflex.addToUpdate(update.bind(gameController));

  messageBus.subscribe('common:PromotionStarted', onPromotionStarted);
  messageBus.subscribe('common:PromotionEnded', onPromotionEnded);

  gameController.canCelebrate = true;
  gameController.extraLiveActive = false;
  gameController.multipliersComplete = false;
  gameController.extraLifeUsed = false;
  gameController.totalExtraLives = 0;

  // console.log('switchState to WAIT_FOR_START');
  // gameController.stateMachine.switchState('WAIT_FOR_START');

  Object.seal(gameController);

  return gameController;
})();

function RNG() {
  const m = 0x80000000;
  const a = 1664525;
  const c = 1013904223;

  let state;

  this.seed = function (newSeed) {
    let seedToUse = newSeed;

    if (typeof newSeed === 'string') {
      let hash = 0;
      for (let i = 0; i < newSeed.length; i++) {
        hash = newSeed.charCodeAt(i) + ((hash << 5) - hash);
        hash = hash & hash;
      }
      seedToUse = Math.abs(hash);
    }
    state = seedToUse ? seedToUse : 0;
  };

  this.seed(0);

  this.nextInt = function () {
    state = (a * state + c) % m;
    return state;
  };

  this.nextFloat = function () {
    return this.nextInt() / (m - 1);
  };

  this.randomNumberFromTo = function (min, max) {
    min = Math.ceil(min);
    max = Math.floor(max + 1);
    return Math.floor(this.nextFloat() * (max - min)) + min;
  };

  this.passChance = function (perc = 100) {
    let pass = false;
    const random = this.randomNumberFromTo(1, 100);
    if (random <= perc) {
      pass = true;
    }
    return pass;
  };
}
